export default {
  common: { loading: 'Chargement…', noData: 'Aucune donnée', clear: 'Effacer', delete: 'Supprimer' },
  errors: { /* notices-i18n */
    generic: 'Une erreur est survenue. Veuillez réessayer.',    codes: {
      // The clock card's refusals (time-api /timer/start and /timer/stop): the card
      // shows the specific reason, as time-ui's own clock button does (issue 700).
      leave_day: 'Ce jour comporte une absence approuvée d’une journée entière — aucun temps de travail ne peut y être enregistré.',
      // A person her contract frees from booking working time (issue 981): time-api refuses the clock-in with this code.
      work_time_booking_off: 'Selon votre contrat, vous ne réservez que du temps de projet, pas de temps de travail.',
      week_approved: 'Cette semaine est déjà approuvée et verrouillée – modification uniquement par demande de correction.',
      week_submitted: 'Cette semaine est soumise et attend une décision – modification uniquement après son retrait ou son renvoi.',
      already_clocked_in: "Vous êtes déjà pointé(e). Fermez d'abord le temps de travail en cours.",
      block_overlap: 'Ce temps de travail chevauche un autre.',
      block_locked: 'Ce temps de travail est verrouillé par une semaine clôturée. Demandez une correction à la place.',
      // user-api's SSO connection PUT (#882): issuer and client are frozen while SSO is enforced.
      sso_enforced: 'Désactivez « Exiger la connexion uniquement via SSO » avant de modifier l’URL de l’émetteur ou le Client ID.',
      // The SSO connection PUT of user-api (issue 926): a list entry that is not a domain.
      invalid_domain: 'L’un des domaines e-mail n’est pas un domaine. Saisissez des domaines comme example.com, sans caractères génériques ni adresses web.',
      // ats-api reports this flat on the envelope; `errorKeyFor` prefers a
      // curated code entry over the status fallback, which is how the custom-field
      // dialog keeps its one specific message without reading the backend string.
      CUSTOM_FIELD_SENSITIVITY_LOCKED: 'Ce champ est déclaré comme donnée sensible ; la déclaration ne peut pas être retirée.',
      LEGAL_NOTICE_BLANK_EMPTY: 'Un champ ne peut pas être rempli avec rien.',
      LEGAL_NOTICE_BLANK_UNKNOWN: 'Ce document ne comporte aucun champ portant ce nom.',
      LEGAL_NOTICE_BLANK_TOKEN: 'Une valeur ne peut pas elle-même contenir un champ à compléter.',
      // The employee-notice gate (issue 576 M3): the invite refusal names WHO
      // can clear it, so an admin sent here knows the fix is not theirs to retry.
      EMPLOYEE_NOTICE_INCOMPLETE: 'Les invitations sont suspendues tant que tous les champs des mentions pour les salariés dans Mentions légales ne sont pas complétés. Demandez au propriétaire de l’espace de travail, à une administration de suite ou au délégué à la protection des données de les compléter.',
      LEGAL_READINESS_UNAVAILABLE: 'Nous n’avons pas pu vérifier si les mentions pour les salariés sont complètes. Veuillez réessayer dans quelques minutes.',
    } as Record<string, string>,
  },
  billing: {
    title: 'Facturation', status: 'Statut', paymentMethod: 'Moyen de paiement',
    updateCard: 'Remplacer la carte', addCard: 'Ajouter une carte',
    invoices: 'Factures', charges: 'Paiements',
    noInvoices: 'Aucune facture pour le moment.', noCharges: 'Aucun paiement pour le moment.',
    noCard: 'Aucun enregistré', validUntil: 'valable jusqu’au {date}',
    trialDaysLeft: '{days} jours restants dans l’essai', trialExpired: 'Essai expiré',
    trialDaysLeftUntil: '{days} jours restants dans votre essai — se termine le {date}',
    // A free_months promo account (issue 808): the whole cardless run, never "trial end" at d2.
    trialDaysLeftFree: '{days} jours gratuits restants — jusqu’au {date}',
    nextChargeOn: 'Prochain prélèvement le {date}',
    exempt: { badge: 'Exonéré de facturation', note: 'lumi a convenu qu’aucun frais ne s’applique actuellement à cet espace de travail.' },
    download: 'Télécharger', dangerZone: 'Zone sensible',
    col: { date: 'Date', period: 'Période', net: 'Net', vat: 'TVA', gross: 'Brut', status: 'Statut', kind: 'Type', amount: 'Montant', document: 'Facture' },
    statusLabel: { trialing: 'Essai', active: 'Actif', delinquent: 'Paiement dû', closed: 'Clôturé', canceled: 'Résilié' },
    tab: { plans: 'Formules', paymentMethod: 'Moyen de paiement', invoices: 'Factures et paiements', referral: 'Parrainage', externalPostings: "Annonces d'emploi", dangerZone: 'Résilier et supprimer' },
    externalPostings: {
      title: "Annonces sur les sites d'emploi externes",
      intro: "Les annonces publiées sur des sites d'emploi externes se commandent une par une et sont facturées à la commande — jusqu'à plusieurs milliers d'euros chacune. Lorsque cette option est active, toute personne dont le rôle de recrutement a la permission « Diffuser à l’extérieur (payant) » peut passer ces commandes — au départ, seuls les administrateurs du recrutement ; chaque commande est facturée à cet espace de travail.",
      switchLabel: "Autoriser la commande d'annonces sur les sites d'emploi externes",
      saving: 'Enregistrement',
      offHint: "La désactivation empêche uniquement les nouvelles commandes. Les annonces déjà en ligne le restent et continuent d'être facturées jusqu'au terme de leur durée.",
      offHintOpenOrders: "Des annonces sont en ligne en ce moment. La désactivation empêche uniquement les nouvelles commandes — les annonces en cours restent en ligne et continuent d'être facturées jusqu'au terme de leur durée.",
      roleNote: "Seul un propriétaire de l'espace de travail, un responsable de facturation ou un administrateur de la suite peut modifier ce réglage. Une personne qui ne doit pas commander d'annonces est arrêtée côté recrutement, en retirant à son rôle la permission « Diffuser à l’extérieur (payant) ».",
      demoNote: "Cet espace de travail est une démonstration. Ses réglages seront remplacés lors de la configuration réelle, ce commutateur reste donc verrouillé jusque-là.",
      noCardTitle: 'Aucun moyen de paiement enregistré',
      noCardBody: "Vous pouvez activer l'option dès maintenant, mais une commande d'annonce ne pourra être payée qu'une fois une carte enregistrée.",
      noCardCta: 'Ajouter une carte',
      savedOn: 'Les annonces externes sont activées. Les recruteurs verront la section de commande au prochain chargement de leur page.',
      savedOff: "Les annonces externes sont désactivées. Aucune nouvelle annonce ne peut être commandée ; les annonces déjà en ligne le restent et continuent d'être facturées.",
    },
    invoiceStatus: { draft: 'En préparation', issued: 'Émise', sent: 'Envoyée', canceled: 'Annulée' },
    chargeKind: { subscription: 'Abonnement', proration: 'Prorata', posting: "Annonce d'emploi", recovery: 'Paiement de rattrapage' },
    posting: { orderRef: 'Commande {ref}', invoice: 'Télécharger la facture' },
    chargeStatus: { created: 'Créé', pending: 'En attente', paid: 'Payé', failed: 'Échoué', authorized: 'Réservé', order_placed: 'Passé', capture_requested: 'Capture demandée', captured: 'Payé', settled: 'Payé', refunded: 'Remboursé', chargeback: 'Rétrofacturation', voided: 'Échoué' },
    bill: { label: 'Facture {number}', labelMany: 'Factures {number}', unnumbered: 'Facture en préparation', paid: 'Payée', closed: 'Clôturée', retry: 'Nouvelle tentative', projected: 'Prévu' },
    // The promo (issue 808, ADR 0100): one line for the phase the account is in.
    promo: { trial: 'Période d\'essai jusqu\'au {start} · puis 1 mois offert jusqu\'au {end} · code {code} | Période d\'essai jusqu\'au {start} · puis {n} mois offerts jusqu\'au {end} · code {code}', run: 'Mois offerts jusqu’au {end} · code {code}', discount: 'Période d\'essai jusqu\'au {start} · puis 1 mois à {percent} % de remise sur les places et les modules · code {code} | Période d\'essai jusqu\'au {start} · puis {n} mois à {percent} % de remise sur les places et les modules · code {code}', discountRun: '{percent} % de remise sur les places et les modules jusqu’au {end} · code {code}', invoiceLine: 'Code promo {code} −{percent} %', referralLine: 'Bonus de parrainage −{percent} %', referralLineCapped: 'Bonus de parrainage −{percent} % (plafonné)' },
    // A module code typed in the add-module dialog (issue 1029, M2).
    modulePromo: { label: 'Code promo (facultatif)', apply: 'Appliquer', remove: 'Retirer', applied: '{code} : {percent} % de remise sur {module} pour 1 facture | {code} : {percent} % de remise sur {module} pour {n} factures', savesToday: 'Le code déduit {amount} du prélèvement d\'aujourd\'hui.', rateLimited: 'Trop de tentatives. Patientez quelques minutes, puis réessayez.', checkFailed: 'Le code ne peut pas être vérifié pour le moment. Vous pouvez ajouter le module sans lui.', notBooked: 'Rien n\'a été réservé – vous pouvez ajouter le module sans le code.', addedWithoutDiscount: 'Le code n\'a pas pu être appliqué, il n\'y a donc pas de remise.', module: { time_tracking: 'Gestion du temps' }, trimmed: '{code} donne {percent} %, mais votre facture porte déjà une remise – sur {module}, vous obtenez {effective} % (toutes les remises d’une même facture sont plafonnées).', trimmedNothing: '{code} donne {percent} %, mais votre facture porte déjà une remise – ce code n’ajoute rien pour le moment.', pending: 'Nous confirmons encore votre code – il apparaîtra sur votre prochaine facture une fois confirmé.', invoiceLine: 'Code promo {code} −{percent} % ({module})', running: '{code} : {percent} % de remise sur 1 facture de plus | {code} : {percent} % de remise sur {n} factures de plus', reason: { unknown: 'Nous ne connaissons pas ce code. Vérifiez son orthographe.', disabled: 'Ce code a été désactivé.', notYetValid: 'Ce code n\'est pas encore valable.', expired: 'Ce code a expiré.', exhausted: 'Vous avez déjà utilisé ce code, ou il est épuisé.', moduleNotEligible: 'Ce code ne couvre pas {module}.', wrongCheckout: 'Ce code est valable pour une nouvelle inscription, pas pour l\'ajout d\'un module.', unavailable: 'Ce code ne peut pas être utilisé ici.' } },
    // The billing door (issue 824): a promo code entered on a running workspace.
    // The workspace's own referral code (issue 824), shown to those who manage billing.
    referral: { title: 'Votre code de parrainage', copy: 'Copier le code', copyLink: 'Copier le lien de commande', copied: 'Code de parrainage copié', linkCopied: 'Lien de commande copié', friendGets: 'Un filleul qui utilise votre code obtient {percent} % de remise sur son premier mois payé. | Un filleul qui utilise votre code obtient {percent} % de remise sur ses {n} premiers mois payés.', youGet: 'Pour chaque entreprise qui commence à payer avec votre code : {percent} % de remise sur une de vos factures — plusieurs s’additionnent, jusqu’à {ceiling} % par facture. | Pour chaque entreprise qui commence à payer avec votre code : {percent} % de remise sur {n} de vos factures — plusieurs s’additionnent, jusqu’à {ceiling} % par facture.', youGetCapped: 'Pour chaque entreprise qui commence à payer avec votre code : {percent} % de remise sur une de vos factures — plusieurs s’additionnent, jusqu’à {ceiling} % par facture ; chaque bonus déduit au maximum {cap} par facture. | Pour chaque entreprise qui commence à payer avec votre code : {percent} % de remise sur {n} de vos factures — plusieurs s’additionnent, jusqu’à {ceiling} % par facture ; chaque bonus déduit au maximum {cap} par facture.', paused: 'Votre code est en pause tant qu’une demande de suppression est ouverte pour votre espace de travail. Il refonctionne dès qu’elle est retirée.', disabled: 'Ce code a été désactivé et ne peut plus être utilisé.', none: { trialing: 'Un code de parrainage vous est attribué dès que votre espace de travail paie, après la période d’essai.', free_run: 'Un code de parrainage vous est attribué dès que les mois offerts sont écoulés et que votre espace de travail paie.', not_billing: 'Un code de parrainage vous est attribué dès que votre espace de travail a un abonnement en cours.' }, loading: 'Chargement de votre code de parrainage …', error: 'Votre code de parrainage n’a pas pu être lu pour le moment. Veuillez réessayer plus tard.', bonus: { title: 'Vos bonus de parrainage', collect: 'Récupérer', ready: 'prêt à être récupéré', startsOn: 'à partir de votre facture du {date}', startsNext: 'à partir de votre prochaine facture', waits: 'attend de la place sur une prochaine facture', carries: 'Votre prochaine facture comporte {items}.', capped: 'plafonné', running: { promo: '{percent} % de code promotionnel', module: '{percent} % de code de module', referral: '{percent} % de bonus de parrainage' }, collected: 'Récupéré — le bonus sera désormais déduit de vos prochaines factures.', alreadyRunning: 'Ce bonus est déjà en cours.', collectFailed: 'Le bonus n’a pas pu être récupéré pour le moment. Veuillez réessayer.', hint: { ceiling: 'Pas encore : votre prochaine facture comporte déjà {running}, et avec ce bonus elle dépasserait la limite de {ceiling} %.', ceilingRunning: 'Pas encore : votre prochaine facture comporte déjà {running}, ce qui ne laisse pas de place à ce bonus.', ceilingLimit: 'Pas encore : avec ce bonus, votre prochaine facture dépasserait la limite de {ceiling} %.', ceilingPlain: 'Pas encore : les remises de votre prochaine facture ne laissent pas de place à ce bonus.', roomNext: 'Un bonus en cours se termine avec votre prochaine facture.', roomLater: 'Le premier bonus en cours se termine dans {n} factures.', notActive: 'Ce bonus attend que votre espace de travail soit de nouveau actif.', deletion: 'Ce bonus attend tant qu’une demande de suppression est ouverte pour votre espace de travail.', unavailable: 'Impossible de vérifier pour le moment si ce bonus peut être récupéré. Veuillez réessayer dans un instant.' } }, history: { title: 'Vos parrainages', empty: 'Personne n’a encore utilisé votre code.', waiting: 'Utilisé le {date} — en attente de son premier mois payé', bonusEarned: 'Gagné le {date} : {percent} % de remise sur 1 facture | Gagné le {date} : {percent} % de remise sur {n} factures', bonusCap: ', plafonné à {cap} par facture', bonusOn: 'sur votre facture de {months} | sur vos factures de {months}', bonusToCome: '{n} à venir', bonusNone: 'pas encore sur une facture' } },
    errors: { setupFailed: 'Échec de la configuration de la carte.', loadFailed: 'Impossible de charger les données de facturation.', ownerOnly: 'Seul le propriétaire de l’espace de travail peut gérer la facturation.', planChangeFailed: 'Impossible de changer votre forfait. Veuillez réessayer.', paymentStanding: 'Réglez votre paiement en attente avant de passer à un forfait supérieur.', cardRequired: 'Ajoutez une carte valide avant de passer à un forfait supérieur.', addModuleFailed: 'Impossible d’ajouter le module. Veuillez réessayer.', cancellationPending: 'Votre abonnement doit prendre fin. Choisissez d’abord « Conserver l’abonnement », puis ajoutez le module.', removeFailed: 'Impossible de programmer la suppression. Veuillez réessayer.' },
    retry: 'Réessayer',
    common: { close: 'Fermer' },
    card: {
      label: 'Carte', title: 'Moyen de paiement',
      remove: 'Supprimer la carte', removed: 'Carte supprimée.',
      inUse: 'Cette carte a déjà été facturée et ne peut être que remplacée, pas supprimée.',
      removeConfirmTitle: 'Supprimer la carte ?', removeConfirmBody: 'Ceci supprime la carte enregistrée. Vous pouvez en ajouter une nouvelle à tout moment.',
      removeError: 'Impossible de supprimer la carte.',
      handoff: 'Envoyer un lien de paiement à une autre personne', handoffTitle: 'Lien de paiement',
      handoffHint: '« Ajouter/remplacer la carte » : vous saisissez vous-même les données de la carte. « Envoyer un lien de paiement à une autre personne » : envoyez un lien à usage unique à la personne qui enregistre la carte — par ex. votre service comptable.',
      handoffBody: 'Partagez ce lien à usage unique avec la personne qui configure la carte. Il expire le {date}.',
      copy: 'Copier', copied: 'Copié', handoffCopied: 'Lien de paiement copié', handoffError: 'Impossible de créer un lien de paiement.',
    },
    recovery: {
      title: 'Paiement en attente · {amount}',
      body: 'Votre banque doit confirmer ce paiement. Confirmez-le maintenant pour conserver votre accès.',
      cta: 'Confirmer le paiement',
      paid: 'Paiement reçu – votre accès est rétabli.',
      failed: 'Le paiement n’a pas été finalisé. Vous pouvez réessayer à tout moment.',
      checking: 'Nous vérifions encore le paiement…',
      startError: 'Le paiement n’a pas pu être lancé pour le moment. Veuillez réessayer dans un instant.',
    },
    plan: {
      title: 'Forfait et modules', subtitle: 'Gérez le forfait de chaque module actif.',
      currentPlan: 'Forfait actuel', current: 'Actuel',
      perMonth: '{amount}/mois', perUserMonth: '{amount} par utilisateur/mois', perApprenticeMonth: '{amount} par apprenti/mois', volumeHint: 'Remise volume : les espaces de travail plus grands paient automatiquement moins par siège.',
      perUpgradeMonth: '{amount} par extension/mois',
      upgrade: 'Passer à un forfait supérieur', downgrade: 'Passer à un forfait inférieur', apply: 'Changer de forfait',
      downgradeNote: 'Les passages à un forfait inférieur prennent effet au début de votre prochain cycle de facturation.',
      fixCardCta: 'Corriger le moyen de paiement',
      enterprise: { title: 'Besoin de plus ?', body: 'Les équipes plus grandes et les conditions personnalisées sont organisées avec notre équipe.', cta: 'Contacter le service commercial' },
      provisioning: 'Configuration en cours — cela peut prendre une minute.',
      provisioningFailed: 'Échec de la configuration — nous nous en occupons.',
      removeModule: 'Supprimer le module', removeConfirmTitle: 'Supprimer le module ?',
      removeConfirmBody: '{module} sera supprimé à la fin de votre cycle de facturation actuel. Vous pouvez annuler cette opération jusque-là.',
      removeScheduled: 'Suppression de {module} programmée.',
      addTitle: 'Ajouter un module', addSubtitle: 'Étendez votre espace de travail avec un module supplémentaire.',
      addCta: 'Ajouter le module', addConfirmTitle: 'Ajouter le module ?',
      moduleLabel: 'Module', planLabel: 'Forfait',
      // The booking table's column heads and its sum row's start date (#409 F12).
      booking: { price: 'Prix', seats: 'Sièges', monthly: 'Par mois', from: 'à partir du {date}' },
      apprenticeSeats: 'Sièges apprenti réservés',
      apprenticeSeatsHint: 'Au moins 1 siège apprenti pour le module apprentissage.',
      apprenticeSeatsCeiling: 'Au-delà de {max} sièges apprenti, il n’existe pas d’offre en libre-service – nous la définissons directement avec vous :',
      apprenticeSeatAdjustment: 'Vous aviez réservé {booked} sièges apprenti avant la suppression de ce module, il a donc été réintégré avec {booked} sièges au lieu des {requested} demandés. Vous pouvez les réduire à partir de votre prochaine facturation.',
      added: '{module} ajouté.',
      addedPaymentRetrying: '{module} a été ajouté et est prêt à l’emploi. Nous n’avons pas pu prélever le paiement pour le moment — nous réessaierons automatiquement.',
      alreadyActive: '{module} fait déjà partie de votre forfait.',
    },
    seats: {
      title: 'Sièges réservés',
      userSeats: 'Sièges utilisateur', apprenticeSeats: 'Sièges apprenti',
      stepUp: 'Plus de sièges', stepDown: 'Moins de sièges',
      bookMore: 'Réserver plus de sièges',
      confirmTitle: 'Réserver plus de sièges ?', confirmCta: 'Réserver les sièges',
      chargeNote: 'Réserver des sièges supplémentaires facture un montant au prorata pour le reste de ce cycle de facturation.',
      confirmTitleDecrease: 'Réduire les sièges réservés ?',
      reduceCta: 'Réduire les sièges',
      decreaseNote: 'Rien n’est facturé ni crédité aujourd’hui — votre réservation change le {date}.',
      decreaseNoteImmediate: 'Rien n’est facturé ni crédité — votre réservation change immédiatement.',
      decreaseScheduled: 'Réduction des sièges programmée pour le {date}.',
      mixedDirection: 'Réservez des sièges supplémentaires et réduisez des sièges en deux étapes distinctes : les sièges ajoutés sont facturés aujourd’hui, les sièges retirés prennent effet à votre prochaine échéance.',
      belowUsage: 'Votre espace de travail utilise plus de sièges que cela. Conservez-en au moins {count}.',
      usageCheckUnavailable: 'Nous n’avons pas pu vérifier combien de sièges sont occupés pour le moment. Veuillez réessayer dans un instant.',
      leaveFreelancer: 'Vous quittez ainsi le mode freelance.',
      returnFreelancer: 'Vous revenez ainsi au mode freelance — une personne, un siège.',
      booked: 'Vos sièges réservés ont été mis à jour.',
      bookedPaymentRetrying: 'Vos sièges sont réservés et prêts à l’emploi. Nous n’avons pas pu prélever le paiement pour le moment — nous réessaierons automatiquement.',
      bookFailed: 'Impossible de réserver les sièges. Veuillez réessayer.',
    },
    seatPanel: {
      inUse: '{used} sur {booked} occupés',
      bookedOnly: '{booked} réservés',
      useUnknown: 'Nous n’avons pas pu lire combien sont occupés pour le moment.',
      manage: 'Gérer les sièges',
      pendingUsers: 'Les sièges utilisateur passent à {target} le {date} — {current} restent réservés jusque-là.',
      pendingApprentices: 'Les sièges apprenti passent à {target} le {date} — {current} restent réservés jusque-là.',
      reflooredUsers: 'Votre réduction à {requested} sièges utilisateur a été appliquée à {booked} : {used} personnes sont dans cet espace et chacune occupe un siège. Retirez celles dont vous n’avez plus besoin, puis réduisez à nouveau.',
      reflooredApprentices: 'Votre réduction à {requested} sièges apprenti a été appliquée à {booked} : {used} apprentissages sont en cours. Terminez ceux dont vous n’avez plus besoin, puis réduisez à nouveau.',
      // A demo workspace's apprentices hold no booked seat (issue 364 F4/F30):
      // the creation gate ignores the booking while the demo runs, so the count
      // excludes them and this row says so.
      demoNotCounted: 'Les apprentis des données de démonstration n\'occupent aucun siège réservé : ils ne sont pas comptés ici et disparaissent lorsque vous validez la démo.',
    },
    // The seat price calculator (issue 364 F30). Every FIGURE it shows arrives
    // from the API; these are only the words around them.
    calc: {
      title: 'Ce que coûte cette réservation',
      includes: 'Ce que comprend votre réservation, et son coût mensuel.',
      userSeatsCount: '{count} sièges utilisateur',
      apprenticeSeatsCount: '{count} sièges apprenti',
      aiQuotaUpgradesCount: '{count} × extension',
      subtotal: 'Sous-total',
      volumeDiscount: 'Remise sur volume',
      monthlyTotal: 'Total mensuel',
      currentTotal: 'Aujourd\'hui, vous payez {amount} par mois.',
      newMonthlyTotal: 'À partir de votre prochaine facture : {amount} par mois.',
      netNote: 'Prix hors TVA. Réserver des sièges supplémentaires entraîne aussi un montant unique au prorata pour le reste du cycle de facturation en cours.',
    },
    // The AI quota card (#665). Every figure it shows arrives from the API.
    aiQuota: {
      title: 'Quota d’IA',
      usageLink: 'Où il est utilisé',
      ownKey: 'Cet espace de travail utilise lumi avec sa propre clé de fournisseur d’IA : il n’a donc pas de quota d’IA — votre fournisseur vous facture directement chaque jeton.',
      suspended: 'Le quota d’IA est suspendu tant que cet espace de travail est suspendu.',
      unlimited: 'Aucun quota d’IA ne s’applique à cet espace de travail — lumi a levé la limite.',
      intro: 'lumi, les fonctions d’IA de chaque module et les agents d’IA externes que les membres connectent partagent un seul quota : jusqu’à {limit} jetons par période de facturation. Il est réinitialisé au début de chaque période de facturation ; les jetons non utilisés ne sont pas reportés.',
      included: 'Inclus',
      includedDerived: 'avec vos sièges réservés',
      includedOverride: 'fixé par lumi pour cet espace de travail',
      tokensValue: '{tokens} jetons par période',
      upgrades: 'Extensions de quota',
      upgradesNone: 'Aucune réservée',
      upgradesValue: 'Réservées : {count} · +{tokens} jetons',
      used: 'Utilisé sur cette période',
      usedValue: '{used} sur {limit} jetons',
      usedNoLimit: '{used} jetons jusqu’ici',
      resetsOn: 'Réinitialisé le {date}',
      stepPrice: 'Une extension ajoute {tokens} jetons par période de facturation pour {amount} par mois.',
      stepUp: 'Une extension de plus',
      stepDown: 'Une extension de moins',
      removeCta: 'Retirer à la prochaine date de facturation',
      confirmTitle: 'Ajouter une extension du quota d’IA ?',
      confirmTitleDecrease: 'Retirer une extension du quota d’IA ?',
      confirmCta: 'Réserver l’extension',
      trialWarning: 'Cela coûte de l’argent réel, même pendant votre essai : votre carte est débitée dès aujourd’hui au prorata du reste de l’essai, pour un mois au maximum, puis chaque mois après sa fin.',
      cardRequired: 'Une extension du quota d’IA nécessite une carte active, même pendant l’essai. Ajoutez d’abord votre carte — dès qu’elle est confirmée, vous pourrez réserver l’extension.',
      promoExcluded: 'Votre code ne s’applique pas au quota d’IA : une extension n’est jamais remisée, elle est facturée au prix catalogue.',
      chargeNote: 'Une extension facture un montant au prorata pour le reste de cette période de facturation et s’applique immédiatement.',
      decreaseNote: 'Rien n’est facturé ni crédité aujourd’hui. Vous conservez l’extension jusqu’au {date} ; ensuite, le quota réduit s’applique.',
      decreaseNoteGeneric: 'Rien n’est facturé ni crédité aujourd’hui — l’extension prend fin à votre prochaine date de facturation.',
      newQuota: 'Ensuite : jusqu’à {limit} jetons par période de facturation.',
      changeDelta: '{tokens} jetons · {amount} / mois',
      addCtaPrice: 'Ajouter une extension de quota · {amount} / mois',
      booked: 'Vos extensions du quota d’IA ont été mises à jour.',
      bookedPaymentRetrying: 'Votre extension du quota d’IA est réservée et s’applique immédiatement. Nous n’avons pas pu prélever le paiement pour le moment — nous réessaierons automatiquement.',
      decreaseScheduled: 'L’extension du quota d’IA prend fin le {date}.',
      pending: 'Les extensions de quota passent à {target} le {date} — {current} restent réservées jusque-là.',
      bookFailed: 'Impossible de modifier les extensions du quota d’IA. Veuillez réessayer.',
    },
    scheduled: {
      resizeTo: 'Passer à {plan}', remove: 'Supprimer le module',
      effective: 'effectif le {date}', revert: 'Annuler', reverted: 'Changement programmé annulé.',
    },
    proration: {
      title: 'Confirmer le changement de forfait', stepFrom: 'Actuel', stepTo: 'Nouveau',
      chargeNote: 'Passer à un forfait supérieur maintenant facture un montant au prorata pour le reste de ce cycle de facturation.',
      freeNote: 'Ce changement s’applique immédiatement sans coût supplémentaire pendant votre essai.',
      confirm: 'Confirmer et passer au forfait supérieur', cancel: 'Annuler',
      charged: '{amount} facturé.', appliedImmediate: 'Votre nouveau forfait est actif.',
      appliedScheduled: 'Programmé — effectif le {date}.',
      calculating: 'Calcul du montant exact…',
      chargeExact: 'Vous serez débité de {amount} aujourd’hui.',
      noChargeToday: 'Aucun prélèvement aujourd’hui.',
    },
    profile: {
      title: 'Coordonnées de facturation', subtitle: 'Complétez vos coordonnées de facturation pour activer le paiement.',
      legalName: 'Raison sociale', addressLine1: 'Adresse', addressLine2: 'Complément d’adresse',
      postalCode: 'Code postal', city: 'Ville', vatId: 'N° de TVA',
      vatOptional: 'Facultatif — requis pour l’autoliquidation au sein de l’UE.',
      save: 'Enregistrer les coordonnées', edit: 'Modifier les coordonnées de facturation', error: 'Impossible d’enregistrer vos coordonnées de facturation.',
      saved: 'Coordonnées de facturation enregistrées.',
      vatPending: 'Nous n’avons pas pu vérifier votre n° de TVA pour le moment. Veuillez réessayer sous peu.',
      vatInvalid: 'Ce n° de TVA n’a pas pu être validé. Veuillez le vérifier.',
      vatRequired: 'Un n° de TVA valide est requis pour votre pays avant d’ajouter une carte.',
      completeFirst: 'Complétez vos coordonnées de facturation avant d’ajouter une carte.',
    },
    cancel: {
      title: 'Résilier l’abonnement',
      body: 'Résiliez votre abonnement. Votre espace de travail reste actif jusqu’à la fin du cycle de facturation en cours.',
      reason: 'Motif (facultatif)', confirm: 'Résilier l’abonnement', confirmTitle: 'Résilier l’abonnement ?',
      confirmBody: 'Votre abonnement prend fin le {date}. Tout continue de fonctionner jusque-là.',
      note: 'D’ici là, tout continue de fonctionner, y compris l’export de l’ensemble de l’espace de travail. Ensuite, l’espace de travail est fermé ; ses données sont conservées un certain temps, et les propriétaires sont prévenus avant toute suppression. Pour qu’il disparaisse plus tôt, passez par « {deletion} ».',
      pending: 'Résiliation programmée — votre abonnement prend fin le {date}.', pendingNoDate: 'Résiliation programmée.',
      revert: 'Conserver l’abonnement', error: 'Impossible de résilier votre abonnement.',
      done: 'Résiliation programmée. Votre espace de travail reste actif jusqu’à la fin de la période de facturation en cours.', revertDone: 'Résiliation annulée. Votre abonnement se poursuit normalement.',
    },
    deletion: {
      title: 'Supprimer l’espace de travail (RGPD)',
      body: 'Demandez la suppression définitive de cet espace de travail et de toutes ses données. Après un court délai de grâce, cette action est irréversible.',
      request: 'Demander la suppression', reason: 'Motif (facultatif)',
      confirmTitle: 'Demander la suppression de l’espace de travail ?',
      confirmBody: 'Toutes les données seront définitivement effacées après un court délai de grâce. Cette action est irréversible.',
      pending: 'Suppression demandée — les données sont effacées après le {date}.', pendingNoDate: 'Suppression demandée et en attente d’examen.',
      cancel: 'Annuler la demande de suppression', error: 'Impossible de soumettre votre demande de suppression.',
      requested: 'Suppression demandée. Nous effacerons votre espace de travail après le délai de grâce.', canceled: 'Demande de suppression retirée. Votre espace de travail est conservé.',
      confirmType: 'Saisissez le nom de l’espace de travail ({name}) pour confirmer',
      cancelConfirmTitle: 'Retirer la demande de suppression ?',
      cancelConfirmBody: 'Votre espace de travail et toutes ses données sont conservés. Vous pouvez demander la suppression à nouveau à tout moment.',
    },
    moduleNames: { core: 'lumi-HR Core', ats: 'Recrutement', time_tracking: 'Temps', apprenticeship: 'Ausbildung' },
    planNames: {
      ats: { seat: 'Par utilisateur', enterprise: 'Enterprise', unknown: '—' },
      time: { seat: 'Par utilisateur', enterprise: 'Enterprise', unknown: '—' },
      apprenticeship: { seat: 'Par apprenti', enterprise: 'Enterprise', unknown: '—' },
      // People Pro is retired (#596), but issued invoices keep their `peoplePro.seat`
      // line (GoBD) and render through this entry — keep it while any exists.
      peoplePro: { seat: 'Par utilisateur', enterprise: 'Enterprise', unknown: '—' },
      // The AI quota upgrade line (#665): its displayKey is `ai_quota.upgrade`.
      ai_quota: { upgrade: 'Extension du quota d’IA (+1 000 000 jetons par période de facturation)' },
    },
    onboard: {
      // Three honest branches, never a CTA without a control (#364 F18/F23).
      // `exempt` is checked FIRST, ahead of demo: an operator-granted exemption
      // is a deliberate state, not a broken signup and not a demo limitation.
      exempt: { title: 'Cet espace de travail est exonéré de facturation', body: 'lumi a convenu qu’aucun frais ne s’applique à cet espace de travail : il n’a donc pas de compte de facturation et rien ne vous est ni ne vous sera facturé. Seul lumi peut modifier cela ; il n’y a rien à configurer ici.' },
      demo: { title: 'La facturation n’est pas disponible en mode démo', body: 'Cet espace de travail fonctionne avec des données de démonstration, il n’y a donc encore rien à facturer. La facturation pourra être configurée dès que vous convertirez la démo en configuration réelle — la bannière de démonstration en haut de la page permet de le faire.' },
      // The stranded signup's real recovery is the buyer redoing the SAME checkout,
      // which resumes THIS workspace (issue 364 F25) — support is the fallback, and
      // for anyone who is not the buyer it is the only route they have.
      stranded: { title: 'La configuration de la facturation n’a pas abouti', buyerBody: 'Votre inscription n’a pas été finalisée : cet espace de travail n’a donc pas encore de compte de facturation et rien ne vous est facturé. Vous pouvez la terminer vous-même : retournez au paiement et commandez les mêmes modules — cet espace de travail reprend là où il s’est arrêté, aucun second espace n’est créé. Si cela ne passe toujours pas, contactez-nous et nous la terminerons avec vous.', otherBody: 'Votre inscription n’a pas été finalisée : cet espace de travail n’a donc pas encore de compte de facturation et rien ne vous est facturé. Seule la personne qui a créé cet espace de travail peut la terminer, en retournant au paiement et en commandant les mêmes modules. Demandez-le-lui, ou contactez-nous et nous la terminerons avec vous.', checkoutCta: 'Retour au paiement', cta: 'Contacter le support' },
    },
    // The four documents this workspace's billing relationship is
    // governed by, on the landing host (#576 M2) — not a "version you
    // accepted" claim, just the current published text.
    contractDocuments: {
      title: 'Documents contractuels',
      terms: 'CGU',
      avv: 'Accord de sous-traitance (AVV)',
      tom: 'Mesures techniques et organisationnelles (TOM)',
      subprocessors: 'Sous-traitants ultérieurs',
    },
  },
  login: {
    ssoApple: 'Se connecter avec Apple',
    passkeySignIn: 'Se connecter avec une clé d’accès',
    passkeySigningIn: 'Connexion…',
    passkeyFailed: 'La connexion par clé d’accès a échoué. Réessayez ou utilisez votre mot de passe.',
    title: 'lumi-HR Suite',
    subtitle: 'Connectez-vous pour continuer',
    email: 'E-mail',
    emailPlaceholder: "nom{'@'}entreprise.fr",
    password: 'Mot de passe',
    passwordPlaceholder: 'Votre mot de passe',
    signIn: 'Se connecter',
    signingIn: 'Connexion en cours…',
    failed: 'Échec de la connexion',
    forgotPassword: 'Mot de passe oublié ?',
    lostPhone: 'Téléphone perdu ?',
    orContinueWith: 'ou continuer avec',
    ssoGoogle: 'Se connecter avec Google',
    ssoMicrosoft: 'Se connecter avec Microsoft',
    ssoEnterprise: 'Se connecter avec le SSO de l’entreprise',
    ssoOnly: 'La connexion à cet espace de travail se fait via le SSO de votre entreprise.',
    adminLogin: 'Connexion administrateur',
    ssoError: 'La connexion SSO a échoué. Veuillez réessayer.',
    ssoSeatLimit: 'Cet espace de travail n’a plus de siège utilisateur libre : nous n’avons pas pu créer de compte pour vous. Demandez au propriétaire de l’espace de travail ou à un Billing Manager de réserver un autre siège — réessayer ne servira à rien avant cela.',
    ssoLinkRequired: 'Cette connexion d’entreprise n’a pas pu être reliée automatiquement à votre compte lumi. Connectez-vous autrement, puis reliez la connexion d’entreprise sous Compte et sécurité.',
    ssoEmployeeNoticeIncomplete: 'Cet espace de travail n’est pas encore prêt : les mentions pour les salariés ont encore des champs à compléter. Demandez au propriétaire de l’espace de travail, à une administration de suite ou au délégué à la protection des données de les compléter dans la section Mentions légales — réessayer ne servira à rien avant cela.',
    ssoLegalReadinessUnavailable: 'Nous n’avons pas pu vérifier si cet espace de travail était prêt pour le moment. Veuillez réessayer dans quelques minutes.',
    ssoOperatorPasswordOnly: 'Les comptes administrateur système se connectent avec leur mot de passe et leur application d’authentification, pas avec ce fournisseur.',
    mfaTitle: 'Saisissez votre code d’authentification',
    mfaIntro: 'Ceci est un compte administrateur système. Saisissez le code à 6 chiffres de votre application d’authentification, ou l’un de vos codes de récupération.',
    mfaCode: 'Code',
    mfaSubmit: 'Se connecter',
    mfaBack: 'Retour',
    mfaInvalid: 'Ce code n’est pas correct.',
    mfaReused: 'Ce code a déjà été utilisé. Attendez le suivant dans votre application.',
    mfaExpired: 'Cette connexion a expiré. Reconnectez-vous avec votre mot de passe.',
    mfaEnrolOnConsole: 'Ce compte administrateur système n’a pas encore d’application d’authentification. Configurez-la d’abord en vous connectant à la console lumi.',
    tenantLogoAlt: 'Logo de l’espace de travail',
    poweredBy: 'Propulsé par',
  },
  loginBranding: {
    nav: 'Page de connexion',
    title: 'Page de connexion',
    intro: 'Donnez à la page de connexion de cet espace de travail votre logo, votre couleur et votre image de fond. Toutes les personnes qui se connectent ici la voient.',
    retry: 'Réessayer',
    loadFailed: 'Les paramètres actuels n’ont pas pu être chargés.',
    form: {
      title: 'Apparence',
      logo: 'Logo',
      logoHint: 'PNG, JPEG, WebP ou GIF, jusqu’à 2 Mo. Laissez vide pour conserver le logo lumi.',
      image: 'Image d’arrière-plan',
      imageHint: 'Affichée derrière la carte de connexion. PNG, JPEG, WebP ou GIF, jusqu’à 8 Mo.',
      upload: 'Téléverser',
      replace: 'Remplacer',
      remove: 'Supprimer',
      empty: 'Aucune image',
      uploaded: 'Image téléversée.',
      removed: 'Image supprimée.',
      tooLarge: 'Ce fichier est trop volumineux.',
      wrongType: 'Seules les images PNG, JPEG, WebP et GIF sont acceptées.',
      uploadFailed: 'L’image n’a pas pu être téléversée. Veuillez réessayer.',
      removeFailed: 'L’image n’a pas pu être supprimée. Veuillez réessayer.',
      removeConfirm: 'L’image est retirée de la page de connexion et supprimée. Cette action est irréversible.',
      primaryColor: 'Couleur principale',
      colorPlaceholder: 'ex. 1a2b3c',
      colorInvalid: 'Saisissez une couleur hexadécimale telle que 1a2b3c.',
      clear: 'Effacer',
      save: 'Enregistrer',
      saved: 'Page de connexion mise à jour.',
      discard: 'Annuler les modifications',
      liveNote: 'Les modifications enregistrées sont visibles au prochain affichage de la page de connexion.',
    },
    preview: {
      title: 'Aperçu',
      hint: 'L’allure de la page de connexion avec les valeurs ci-dessus.',
      logoAlt: 'Aperçu du logo',
    },
  },
  authFlow: {
    forgot: {
      title: 'Réinitialiser votre mot de passe',
      subtitle: 'Nous vous enverrons un lien pour le réinitialiser.',
      email: 'E-mail',
      submit: 'Envoyer le lien',
      done: 'Si un compte est associé à cette adresse e-mail, nous avons envoyé un lien de réinitialisation.',
      backToLogin: 'Retour à la connexion',
    },
    reset: {
      title: 'Définir un nouveau mot de passe',
      password: 'Nouveau mot de passe',
      confirm: 'Confirmer le mot de passe',
      submit: 'Enregistrer le mot de passe',
      success: 'Votre mot de passe a été modifié. Vous pouvez maintenant vous connecter.',
      goToLogin: 'Aller à la connexion',
      invalid: 'Ce lien est invalide ou a expiré.',
      mismatch: 'Les mots de passe ne correspondent pas.',
      tooShort: 'Le mot de passe doit comporter au moins 8 caractères.',
      missingToken: 'Aucun token valide trouvé.',
    },
    invite: {
      title: 'Configurer votre compte',
      subtitle: 'Choisissez un mot de passe pour activer votre compte.',
      forTenant: 'Invitation à {tenant}',
      password: 'Mot de passe',
      confirm: 'Confirmer le mot de passe',
      submit: 'Activer le compte',
      submitting: 'Activation…',
      invalid: 'Cette invitation est invalide ou a expiré.',
      mismatch: 'Les mots de passe ne correspondent pas.',
      tooShort: 'Le mot de passe doit comporter au moins 8 caractères.',
      passkey: {
        title: 'Configurer votre connexion',
        intro: 'Vous vous connectez à lumi avec une clé d’accès : empreinte, visage ou code de l’appareil. Aucun mot de passe à retenir.',
        sentTo: 'Envoyé au {phone}',
        create: 'Créer une clé d’accès',
        creating: 'En attente de votre appareil…',
        instead: 'Utiliser plutôt une clé d’accès',
        or: 'ou',
        unsupported: 'Ce navigateur ne peut pas créer de clé d’accès. Ouvrez le lien sur votre téléphone ou dans un navigateur à jour.',
        unavailable: 'Les clés d’accès ne sont pas disponibles ici pour cet espace de travail. Veuillez contacter votre administrateur.',
        expired: 'Cela a pris trop de temps. Veuillez réessayer.',
        alreadyRegistered: 'Cet appareil possède déjà une clé d’accès pour lumi.',
        failed: 'La clé d’accès n’a pas pu être créée. Veuillez réessayer.',
      },
    },
    recover: {
      title: 'Téléphone perdu ?',
      subtitle: 'Saisissez votre numéro de mobile et nous vous enverrons par SMS un lien pour configurer une nouvelle clé d’accès.',
      phone: 'Numéro de mobile',
      phoneHint: 'Avec l’indicatif du pays, par ex. +33 6 12 34 56 78',
      submit: 'Envoyer le lien',
      done: 'Si ce numéro correspond à un compte ici, nous lui avons envoyé un lien. Il est valable 15 minutes.',
      enrolTitle: 'Configurer une nouvelle clé d’accès',
      enrolSubtitle: 'Créez une clé d’accès sur cet appareil. Toutes les autres sessions de votre compte seront déconnectées.',
      create: 'Créer une nouvelle clé d’accès',
      invalid: 'Ce lien est invalide ou a expiré. Demandez-en un nouveau.',
    },
    verify: {
      verifying: 'Confirmation de votre e-mail…',
      success: 'Votre adresse e-mail a été confirmée.',
      invalid: 'Ce lien de confirmation est invalide ou a expiré.',
      backToLogin: 'Aller à la connexion',
    },
  },
  account: {
    // AI agent connections on the account page (ADR 0103 rule 13).
    agentConnections: {
      title: 'Connexions d’agents IA',
      hint: 'Les clients IA que vous avez autorisés à agir en votre nom dans un espace. Chacun travaille avec exactement vos autorisations, et ce qu’il lit est transmis au fournisseur de ce client.',
      none: 'Aucun agent IA n’est connecté.',
      inWorkspace: 'dans l’espace {workspace}',
      scope: {
        read: 'lire',
        act: 'agir avec confirmation',
        ask: 'interroger lumi',
      },
      lastUsed: 'Dernière utilisation le {when}',
      connectedOn: 'Connecté le {when}, pas encore utilisé',
      standing: {
        label: 'Exécuter les actions sur mes propres données sans demander',
        hint: 'Ne couvre jamais les données d’autres personnes ni les décisions défavorables.',
        notOffered: 'Cette connexion ne peut pas recevoir de consentement permanent.',
        failed: 'Le réglage n’a pas pu être modifié. Veuillez réessayer.',
      },
      rolePins: {
        notHeld: 'Vous n’avez plus ce rôle dans ce module.',
        failed: 'Le rôle n’a pas pu être modifié. Veuillez réessayer.',
      },
      disconnect: 'Déconnecter',
      disconnectConfirm: '« {client} » perd immédiatement l’accès à {workspace}. Pour l’utiliser à nouveau, reconnectez-le depuis le client.',
      disconnected: '{client} déconnecté.',
      disconnectFailed: 'La connexion n’a pas pu être fermée. Veuillez réessayer.',
    },
    passkeys: {
      removeConfirm: 'Cette clé d’accès sera retirée. L’appareil qui l’utilise ne pourra plus s’en servir pour se connecter.',
      title: 'Clés d’accès',
      hint: 'Une clé d’accès vous connecte avec votre appareil — empreinte, visage ou code. Rien à retenir et rien à hameçonner.',
      none: 'Aucune clé d’accès pour l’instant.',
      add: 'Ajouter une clé d’accès',
      remove: 'Supprimer',
      unnamed: 'Clé d’accès',
      lastUsed: 'Dernière utilisation le {when}',
      neverUsed: 'Jamais utilisée',
      added: 'Clé d’accès ajoutée.',
      removed: 'Clé d’accès supprimée.',
      addFailed: 'La clé d’accès n’a pas pu être ajoutée. Veuillez réessayer.',
      removeFailed: 'La clé d’accès n’a pas pu être supprimée. Veuillez réessayer.',
      alreadyRegistered: 'Cet appareil possède déjà une clé d’accès pour lumi.',
      lastMethod: 'Vous ne pouvez pas supprimer votre seule méthode de connexion. Définissez d’abord un mot de passe ou ajoutez une autre clé d’accès.',
      lostDevice: 'Vous avez perdu un téléphone ou un autre appareil ? Supprimez sa clé d’accès de cette liste — c’est ce qui lui ferme l’accès à votre compte.',
    },
    currentPassword: 'Mot de passe actuel',
    phone: {
      title: 'Numéro de connexion',
      hint: 'Votre compte se connecte avec une clé d’accès. Ce numéro reçoit vos liens d’invitation et de récupération.',
    },
    email: {
      title: 'Adresse de connexion',
      hint: 'L\'adresse avec laquelle vous vous connectez. La modifier change aussi l\'adresse que vos espaces de travail affichent pour vous.',
      newLabel: 'Nouvelle adresse',
      submit: 'Demander la modification',
      pending: 'En attente de confirmation à {email}. Suivez le lien que nous y avons envoyé.',
      cancel: 'Annuler cette modification',
      cancelled: 'La modification d\'adresse en attente a été annulée.',
      sent: 'Consultez la nouvelle boîte mail. Rien ne change tant que vous n\'avez pas suivi le lien.',
      refused: 'Cette adresse ne peut pas être utilisée pour ce compte. L\'un de vos espaces de travail limite les adresses de connexion à ses propres domaines.',
      failed: 'La modification n\'a pas pu être demandée. Veuillez réessayer.',
      ssoManaged: 'Votre adresse de connexion est gérée par votre fournisseur d\'identité.',
    },
    password: {
      title: 'Mot de passe',
      hint: 'Changer votre mot de passe vous déconnecte partout ailleurs.',
      newLabel: 'Nouveau mot de passe',
      confirmLabel: 'Répéter le nouveau mot de passe',
      submit: 'Changer le mot de passe',
      changed: 'Votre mot de passe a été modifié. Les autres appareils ont été déconnectés.',
      wrongCurrent: 'Le mot de passe actuel est incorrect.',
      failed: 'Le mot de passe n\'a pas pu être modifié. Veuillez réessayer.',
      tooShort: 'Le nouveau mot de passe doit comporter au moins 8 caractères.',
      mismatch: 'Les deux nouveaux mots de passe ne correspondent pas.',
      ssoOnly: 'Ce compte se connecte via votre fournisseur d\'identité et n\'a donc pas de mot de passe. Vous pouvez en ajouter un en secours — nous vous enverrons un lien.',
      sendLink: 'M\'envoyer un lien pour définir un mot de passe',
      linkSent: 'Si un mot de passe peut être défini pour ce compte, un lien est en route.',
      linkFailed: 'La demande n\'a pas pu être envoyée. Veuillez réessayer.',
    },
    confirmEmail: {
      title: 'Confirmez votre nouvelle adresse',
      working: 'Confirmation en cours…',
      success: 'Votre adresse de connexion a été modifiée. Veuillez vous reconnecter avec la nouvelle adresse.',
      goToLogin: 'Aller à la connexion',
      backToAccount: 'Retour à Compte et sécurité',
      missingToken: 'Ce lien est incomplet. Veuillez l\'ouvrir directement depuis l\'e-mail.',
      invalid: 'Ce lien de confirmation est invalide ou a expiré.',
      unavailable: 'Cette modification ne peut plus être appliquée. Veuillez la redemander.',
    },
    // The undo half (#420): the notice mailed to the address being LEFT
    // BEHIND carries this link, and it only ever restores the status quo.
    cancelEmailChange: {
      title: 'Annuler la modification d\'adresse',
      working: 'Annulation…',
      success: 'La modification a été annulée. Vous continuez à vous connecter avec votre adresse actuelle.',
      goToLogin: 'Aller à la connexion',
      missingToken: 'Ce lien est incomplet. Ouvrez-le directement depuis l\'e-mail.',
      invalid: 'Ce lien est invalide ou expiré — il n\'y a plus de modification à annuler.',
    },
    title: 'Compte et sécurité',
    identities: 'Méthodes de connexion associées',
    noIdentities: 'Aucune méthode de connexion externe associée.',
    unlink: 'Supprimer',
    // #882: removing a linked sign-in method asks first, as removing a passkey does.
    unlinkConfirm: 'Cette méthode de connexion sera supprimée. Vous ne pourrez plus vous connecter à votre compte avec elle.',
    linkGoogle: 'Associer Google',
    linkMicrosoft: 'Associer Microsoft',
    linkApple: 'Associer Apple',
    lastMethod: 'Vous ne pouvez pas supprimer votre unique méthode de connexion. Définissez d’abord un mot de passe.',
    linked: 'Méthode de connexion associée.',
    unlinked: 'Méthode de connexion supprimée.',
    linkFailed: 'Échec de l’association.',
  },
  workspace: {
    title: 'Espace de travail',
    subtitle: 'Choisissez un tenant et un module',
    brandName: 'lumi-HR Workspace',
    themeDark: 'Passer en mode sombre',
    themeLight: 'Passer en mode clair',
    welcomeTitle: 'Bienvenue dans l’espace de travail',
    welcomeSubtitle:
      'Sélectionnez votre tenant et un module applicatif pour commencer.',
    availableModules: 'Modules disponibles',
    comingSoonSection: 'Bientôt dans lumi-HR',
    adminMode: 'Mode administrateur',
    aiUsage: {
      title: 'Utilisation de l’IA',
      pageIntro: 'Si lumi est disponible dans cet espace de travail, et ce que l’IA a consommé ce mois-ci.',
      loading: 'Chargement de l’utilisation…',
      remaining: '{n} restants',
      periodLabel: 'Période de facturation',
      historyTitle: 'Périodes de facturation',
      usedThisPeriod: 'Utilisé sur cette période de facturation',
      split: '{included} inclus · +{upgrades} grâce aux extensions de quota',
      resetsOn: 'Réinitialisé le {date}',
      periodFrom: 'Période de facturation à partir du {date}',
      nearLimit: 'Le quota d’IA de cette période de facturation est presque épuisé. Une extension de quota dans Facturation l’augmente immédiatement.',
      unlimited: 'Aucun quota d’IA ne s’applique à cet espace de travail.',
      ownKey: 'Cet espace de travail utilise lumi avec sa propre clé de fournisseur d’IA : il n’a donc pas de quota d’IA.',
      noUsageYet: 'Aucune utilisation de l’IA sur cette période de facturation.',
      upgradeLink: 'Ajouter une extension de quota dans Facturation',
      modules: {
        ats: 'Recrutement',
        time: 'Temps',
        time_tracking: 'Temps',
        apprentice: 'Ausbildung',
        apprenticeship: 'Ausbildung',
        assistant: 'Assistant lumi',
        mcp: 'Agents externes',
      },
    },
    active: 'Actif',
    systemAdmin: 'Administrateur système',
    user: 'Utilisateur',
    admin: 'Administration',
    comingSoon: 'Bientôt disponible',
    noTenants: 'Aucun tenant disponible',
    createViaCheckout: 'Créer un espace de travail via la page de paiement',
    loadFailed: 'Impossible de charger les tenants',
    planKlein: 'Petit',
    planMedium: 'Moyen',
    planEnterprise: 'Entreprise',
    retry: 'Réessayer',
    logout: 'Se déconnecter',
    noAccess: 'Pas d\'accès',
  },
  support: {
    title: 'Demandes de support',
    myTickets: 'Mes demandes',
    myTicketsTitle: 'Mes demandes de support',
    inbox: 'Boîte de réception',
    inboxTitle: 'Boîte de réception du support',
    inboxSubtitle: 'Tickets des tenants que vous prenez en charge',
    ticket: 'Ticket',
    newTicket: 'Nouvelle demande de support',
    newTicketTitle: 'Nouvelle demande de support',
    newTicketIntro: 'Décrivez votre problème et nous reviendrons vers vous.',
    sent: 'Votre demande a été envoyée.',
    goToMyRequests: 'Voir mes demandes de support',
    subject: 'Objet',
    subjectPlaceholder: 'Bref résumé',
    message: 'Message',
    messagePlaceholder: 'Décrivez ce qui s’est passé…',
    consentLabel: 'Je reconnais que mes données sont traitées pour gérer cette demande',
    send: 'Envoyer',
    reply: 'Répondre',
    markComplete: 'Marquer comme résolu',
    reopen: 'Rouvrir',
    replyPlaceholder: 'Écrire une réponse…',
    escalate: 'Escalader',
    escalated: 'Escaladé',
    deescalate: 'Désescalader',
    deescalateBlocked: 'Un accès support est encore ouvert sur ce ticket. Révoquez-le d’abord, puis désescaladez.',
    close: 'Clôturer',
    statusLabel: 'Statut',
    module: 'Module',
    tenant: 'Tenant',
    requester: 'Demandeur',
    updated: 'Mis à jour',
    backToTickets: 'Retour à mes demandes',
    status: {
      open: 'Ouvert',
      in_progress: 'En cours',
      answer: 'Répondu',
      closed: 'Clôturé',
    },
    author: {
      user: 'Vous',
      support: 'Support',
      systemAdmin: 'Administrateur système',
    },
    empty: {
      myTitle: 'Aucun ticket pour l’instant',
      myBody: 'Lorsque vous créez un ticket de support, il apparaît ici.',
      inboxTitle: 'Rien à prendre en charge',
      inboxBody: 'Vous n’avez aucun ticket de support dans vos tenants pour le moment.',
      notFoundTitle: 'Ticket indisponible',
      notFoundBody: 'Ce ticket n’a pas pu être chargé. Il a peut-être été supprimé ou vous n’y avez pas accès.',
    },
  },
  notifications: {
    nav: 'Notifications',
    title: 'Notifications',
    subtitle: 'Ce qui nécessite votre attention.',
    settings: 'Paramètres',
    backToWorkspace: 'Retour à l’espace de travail',
    area: 'Domaine',
    areaAll: 'Tous les domaines',
    status: 'Statut',
    statusAll: 'Tous',
    statusUnread: 'Non lus',
    statusRead: 'Lus',
    perPage: 'Par page',
    markRead: 'Marquer comme lu',
    markUnread: 'Marquer comme non lu',
    markAllRead: 'Tout marquer comme lu',
    loading: 'Chargement…',
    empty: 'Vous êtes à jour.',
    pageInfo: '{from}–{to} sur {total}',
    prev: 'Précédent',
    next: 'Suivant',
    retentionHint: 'Les notifications sont conservées pendant 6 mois.',
    settingsTitle: 'Configurer les notifications par domaine',
    settingsSubtitle: 'Choisissez comment être notifié pour chaque domaine.',
    // #445 M4 packet 2: the settings screen must say plainly what it cannot
    // switch off, and what a switched-off Area still lets through.
    mustReachIntro: "Quelques notifications concernant la sécurité, l'argent, les contrats, votre espace de travail et les délais légaux parviennent toujours aux personnes concernées — elles apparaissent aussi dans la cloche.",
    // A phone-only account (issue 698): no address, so the mail half never goes out.
    noMailAddress: 'Votre compte n’a pas d’adresse e-mail : les notifications vous parviennent donc dans l’application (et en notification push si vous l’avez autorisée). « {mailMode} » fonctionne ainsi comme « {inAppMode} » : rien n’est envoyé par e-mail.',
    mustReachStillReaches: "Même désactivé, {list} continueront de vous parvenir lorsqu'ils vous concernent.",
    mandatoryReason: {
      billing: 'Ne peut pas être désactivé : les sommes dues doivent parvenir à la personne responsable.',
      legal: 'Ne peut pas être désactivé : les modifications contractuelles doivent vous parvenir, comme le prévoient nos conditions.',
    },
    mustReachFamily: {
      identity: 'notifications de sécurité',
      money: 'notifications de facturation',
      legal: 'notifications contractuelles',
      workspace: 'notifications sur l’état de l’espace de travail',
      privacy: 'rappels de délais de confidentialité',
      participation: 'demandes aux représentants du personnel',
    },
    backToList: 'Retour aux notifications',
    modeOff: 'Pas du tout',
    modeInApp: 'Application uniquement',
    modeMailInApp: 'E-mail et application',
    saved: 'Enregistré.',
    saveError: 'Enregistrement impossible. Le réglage a été rétabli.',
    openTarget: 'Ouvrir l\'élément lié',
    opening: 'Ouverture…',
    openFailed: 'Impossible d’ouvrir cette notification.',
    areas: {
      system: 'Système',
      timecard: 'Temps',
      ats: 'Recrutement',
      apprentice: 'Ausbildung',
      people: 'Personnel',
      support: 'Support',
      postings: 'Offres d’emploi',
      // Subscription, invoices, payment problems. A MANDATORY Area — the
      // row renders without a mode selector (review finding 3).
      billing: 'Facturation',
      // #373 M5: the contract-rollout notices (AGB, AVV, subprocessors). A
      // MANDATORY Area — the row renders without a mode selector.
      legal: 'Documents contractuels',
    },
  },
  homebase: {
    // The owner's own details, asked for on Suite Home until given (issue 812); skipping asks first.
    ownDetails: {
      save: 'Enregistrer mes informations',
      later: 'Plus tard',
      saved: 'Merci — vos informations sont enregistrées.',
      skip: {
        title: 'Passer vos informations ?',
        body: 'Tant que vous ne renseignez pas vos informations, votre fiche reste non confirmée dans Personnel. Concrètement : aucune donnée salarié (contrat, congés, paie) ne peut y être ajoutée, vous ne pouvez être désigné·e responsable de personne et vous apparaissez comme « non confirmé·e » dans Personnel. Vous pouvez le faire à tout moment — ce rappel reviendra demain.',
        fill: 'Remplir maintenant',
        skip: 'Passer pour l’instant',
      },
    },
    // The quiet "set up Lumi" panel on Suite Home: one fixed table of entries,
    // each a title + one benefit line; the rows are looked up per entry key.
    setup: {
      title: 'Configurer lumi',
      subtitle: 'Rien n\'est obligatoire. Tout est utile le moment venu.',
      hide: 'Je n\'en ai plus besoin',
      viewAll: 'Voir tout ce que lumi sait faire',
      rareHeading: 'Moins souvent utilisé',
      page: {
        title: 'Ce que lumi sait faire.',
        subtitle: 'Tout ce qui peut être configuré. L\'essentiel d\'abord, le reste quand vous en avez besoin.',
        tipsTitle: 'Conseils sur la page d\'accueil',
        tipsShown: 'Le panneau reste en haut de votre page d\'accueil tant que vous en avez besoin.',
        tipsHidden: 'Vous avez masqué le panneau. Vous pouvez le réafficher ici.',
        emptyTitle: 'Rien à configurer pour vous ici.',
        emptyBody: 'Ce qui peut être configuré est pris en charge par les responsables de votre équipe. Adressez-vous à eux s\'il vous manque quelque chose.',
      },
      sections: {
        suite: 'Accueil',
        ats: 'Recrutement',
        time: 'Temps',
        people: 'Personnel',
        apprentice: 'Ausbildung',
      },
      entries: {
        login_branding: { title: 'Personnaliser la page de connexion', hint: 'Logo et couleurs, pour que votre équipe sache qu\'elle est au bon endroit.' },
        portal_design: { title: 'Personnaliser le portail carrières', hint: 'La première impression que les candidats ont de votre entreprise.' },
        email_templates: { title: 'Modèles d\'e-mail', hint: 'Accusé de réception, invitation, refus : à rédiger une fois, à réutiliser toujours.' },
        job_posting_settings: { title: 'Informations pour les offres d\'emploi', hint: 'Logo et interlocuteur. Les sites d\'emploi externes ont besoin des deux.' },
        work_time_models: { title: 'Modèles de temps de travail', hint: 'Qui travaille combien d\'heures, et quels jours.' },
        company_holidays: { title: 'Fermetures de l\'entreprise', hint: 'Les jours où l\'entreprise est fermée.' },
        data_import: { title: 'Importer des personnes', hint: 'Reprendre vos listes existantes au lieu de tout saisir.' },
        company_profile: { title: 'Profil de l\'entreprise', hint: 'Adresse et données clés que lumi utilise à de nombreux endroits.' },
        org_units: { title: 'Unités d\'organisation', hint: 'Services et sites selon lesquels beaucoup de choses se classent.' },
        payroll_handover: { title: 'Transmission de la paie (DATEV)', hint: 'lumi fournit les heures, votre expert-comptable calcule la paie.' },
        training_occupations: { title: 'Métiers de la formation', hint: 'Les métiers que vous formez.' },
        workflows: { title: 'Workflows', hint: 'Vos propres étapes et validations dans le processus de candidature.' },
        application_forms: { title: 'Formulaires de candidature', hint: 'Les questions auxquelles répondent les candidats.' },
        offer_templates: { title: 'Modèles d\'offre', hint: 'Préparer des offres de contrat avec des champs variables.' },
        custom_fields: { title: 'Champs personnalisés', hint: 'Informations supplémentaires sur les postes et les candidatures.' },
        booking_types: { title: 'Types de saisie', hint: 'Ce qui peut être saisi en plus du temps de travail.' },
        leave_types: { title: 'Types d\'absence', hint: 'Congés, maladie et vos propres types.' },
        api_settings: { title: 'Interface (API)', hint: 'Transmettre les temps à vos propres programmes via l’API. La transmission de la paie se trouve sous Personnel.' },
        time_clock: { title: 'Pointeuse', hint: 'L\'ouvrir dans le navigateur d\'une tablette sur place : chaque personne s\'y connecte avec son propre accès lumi et pointe.' },
        sso: { title: 'Single Sign-on', hint: 'Connexion avec le compte de votre entreprise.' },
        onboarding_templates: { title: 'Modèles d\'accueil', hint: 'Listes de contrôle pour les premiers jours des nouveaux collègues.' },
        recruiting_options: { title: 'Listes d\'options', hint: 'Civilités, types de contrat et lieux de travail parmi lesquels votre équipe choisit.' },
      },
    },
    greeting: { morning: 'Bonjour', day: 'Bonjour', evening: 'Bonsoir' },
    // La ligne de date sous la salutation ("Lundi 21 septembre · Semaine 39",
    // workspace-start M2) remplace le sous-titre statique.
    dateLine: { week: 'Semaine {n}' },
    open: 'Ouvrir',
    recents: 'Récents',
    recentKinds: { report: 'Rapport hebdo.', job: 'Poste', application: 'Candidature' },
    moreActions: 'Autres actions',
    clockedInSince: 'Pointé depuis {time}',
    clockedOut: 'Sortie pointée',
    clockOut: 'Pointer la sortie',
    clockIn: 'Pointer l’arrivée',
    projectRunning: 'Temps de projet en cours',
    projectRunningSince: 'Depuis {time}',
    startProject: 'Démarrer un projet',
    // The clock tile for a person freed from booking working time (issue 981): the sentence, then the way to a project.
    workTimeFree: 'Selon votre contrat, vous ne réservez que du temps de projet, pas de temps de travail.',
    // The Stempeluhr's project choice once clocked in (Zeit's "Woran arbeitest du?"): the tile's field and its sheet.
    clockProject: {
      title: 'Sur quoi travaillez-vous ?',
      none: 'Sans projet',
      noneSub: 'Compte comme « Non affecté »',
      choose: 'Choisir le projet et l’activité',
      fieldLabel: 'Sur quoi travaillez-vous ? Actuellement : {current}',
      runningWith: '{activity} · depuis {time}',
      runningSince: 'Depuis {time}',
      activityStep: 'Quelle activité ?',
      back: 'Tous les projets',
      defaultActivity: 'Par défaut',
      search: 'Rechercher un projet',
      noMatch: 'Aucun projet trouvé',
      close: 'Fermer',
    },
    provisioning: 'Configuration en cours — cela peut prendre une minute.',
    preferences: 'Préférences',
    seeMyOrg: 'Mon organisation',
    // What each module Lumi still sells actually does (issue 261 M2). Longer than the
    // launcher's one-liners (app-kit's `lumiModules.<key>.description`): this is one
    // app, so the home can say it in the module's own vocabulary.
    teaser: {
      about: {
        ats: 'Offres d’emploi, candidatures et pipeline de recrutement — du premier CV au contrat signé.',
        time_tracking: 'Pointage, compteurs de temps de travail, absences et heures supplémentaires, prêts pour le relevé légal.',
        apprenticeship: 'Livrets d’apprentissage numériques, plans de formation et évaluations pour chaque apprenti.',
      },
      heading: 'Autres modules',
    },
    empty: 'Rien ici pour l’instant — ouvrez le module pour commencer.',
    unavailable: 'Impossible à charger pour le moment.',

    goToModule: 'Aller à {module}', expand: 'Développer {module}', collapse: 'Réduire {module}',
    themeLight: 'Clair',
    themeDark: 'Sombre',
    people: { selfService: 'Mes données' },
    myDocuments: {
      title: 'Mes documents',
      downloadFailed: 'Échec du téléchargement – veuillez réessayer plus tard.',
      showAll: 'Tout afficher ({count})',
      showLess: 'Afficher moins',
      handIn: 'Remettre un document',
      empty: 'Rien pour l\'instant. Vous pouvez remettre un certificat, une attestation, un arrêt maladie ou une copie de pièce d\'identité pour votre dossier.',
      kindLabel: 'De quoi s’agit-il ?',
      fileLabel: 'Fichier – choisir ou prendre en photo',
      send: 'Envoyer',
      cancel: 'Annuler',
      handedIn: 'Remis le {date} · en attente des RH',
      accepted: 'Remis le {date} · accepté',
      sentBack: 'Renvoyé le {date} : « {reason} »',
      handInAgain: 'Remettre à nouveau',
      dismiss: 'Masquer',
      error: {
        file_refused: 'Ce fichier n\'a pas pu être accepté – veuillez essayer un autre fichier.',
        file_too_large: 'Ce fichier est trop volumineux – la limite est de 25 Mo.',
        file_empty: 'Ce fichier est vide – veuillez choisir un autre fichier.',
        file_missing: 'Veuillez d\'abord choisir un fichier.',
        quota_exceeded: 'Votre dossier a atteint sa limite de stockage – veuillez contacter les RH.',
        invalid_category: 'Veuillez indiquer de quel type de document il s’agit.',
        not_possible: 'La remise n\'est pas possible pour le moment – veuillez contacter les RH.',
        generic: 'La remise a échoué – veuillez réessayer plus tard.',
        scan_unavailable: 'Le fichier n’a pas pu être vérifié pour le moment. Veuillez réessayer dans un instant.',
      },
      category: {
        contract: 'Contrat de travail',
        contract_amendment: 'Avenant au contrat',
        certificate: 'Certificat / attestation de travail',
        attestation: 'Attestation',
        payslip: 'Bulletin de paie',
        health_certificate: 'Arrêt maladie / certificat médical',
        identification: 'Pièce d\'identité',
        other: 'Autre',
      },
    },
    admin: {
      users: 'Utilisateurs',
      usersMoved: {
        title: 'La gestion des utilisateurs a été déplacée dans Personnel',
        redirecting: 'Ouverture de Personnel…',
        noPeople: 'Les accès à cet espace de travail se gèrent sur la fiche de chaque personne dans Personnel. Personnel n’est pas disponible pour vous ici : adressez-vous au propriétaire de l’espace de travail.',
      },
    },
    verwaltung: { heading: 'Gestion' },
    nav: { home: 'Tableau de bord', billing: 'Facturation', logout: 'Se déconnecter', language: 'Langue', administration: 'Administration', sso: 'Single Sign-On', audit: 'Journal d’audit', supportAccess: 'Accès du support', aiUsage: 'Utilisation de l’IA', dataProcessing: 'Traitement des données', dataRequests: 'Demandes des personnes concernées', legalNotices: 'Mentions légales', statutoryRules: 'Règles légales', trainingOccupations: 'Métiers de formation', externalAgents: 'Agents IA externes', setup: 'Configurer' },
    // The running week against its Sollstunden (#403). `hoursUnit` is a
    // separate key because the figures are formatted with Intl and the unit
    // trails them in every language this app ships.
    week: {
      title: 'Cette semaine',
      hoursUnit: 'h',
      balance: 'Compte horaire au {date} : {balance}',
      balanceHint: 'Heures travaillées moins heures dues jusqu’à ce jour.',
      noTarget: 'Aucune durée hebdomadaire définie.',
      trustBased: 'Vous travaillez en temps de travail basé sur la confiance : vous enregistrez le début et la fin de votre travail, et il n’y a ni cible ni compte horaire pour vous.',
      projectsMore: 'et {n} de plus',
      days: 'Jours de la semaine',
    },
    heute: {
      clock: 'Pointeuse',
      attention: 'Vous concerne',
      news: 'Nouveau',
      leaveRemaining: 'Congés restants',
      days: 'Jour | Jours',
      kind: { interview: 'Entretien', leave: 'Absences', holiday: 'Jour férié', exam: 'Examen', station: 'Changement de service' },
    },
    facts: {
      ats: { total_jobs: 'Postes', total_applications: 'Candidatures', open_tasks: 'Tâches ouvertes', new_applicants: 'Nouveaux candidats', create_job: 'Créer un poste', add_application: 'Ajouter une candidature', create_task: 'Créer une tâche', pipeline: 'Pipeline', pipeline_closed: '{n} clôturées', stage_other: 'Autres' },
      time: { week_hours: 'Heures cette semaine', today_hours: 'Heures aujourd’hui', timesheet: 'Mes temps', request_leave: 'Demander un congé', approvals: 'Validations', team: 'Équipe', pending_approvals: 'Validations en attente', leave_remaining: 'Congés restants', proof_open: 'Justificatif manquant' },
      apprentice: { waiting: 'À valider', active: 'Apprentis', overdue: 'Semaines manquantes', this_week: 'Cette semaine', badges: 'Compétences', write: 'Saisir la semaine', skills: 'Mur des compétences', review: 'Valider les rapports', onboard: 'Ajouter un apprenti', reports: 'Carnets de rapports', report_approved: 'Validés', report_submitted: 'À valider', report_rejected: 'Renvoyés', report_missing: 'Manquants' },
    },
  },
  preferences: {
    appearance: 'Apparence',
    theme: 'Thème',
    themeHint: 'Interface claire ou sombre.',
    language: 'Langue',
    languageHint: 'La langue utilisée dans tout l’espace.',
    attributions: 'Attributions des données ouvertes',
    placesCredit: 'Données de lieux © {source}, sous licence {licence}.',
    bankCodesCredit: "Codes bancaires : source {bundesbank} ; codes bancaires autrichiens © {oenb}, sous licence {licence} ; codes suisses et liechtensteinois © {six}.",
    healthInsurersCredit: "Caisses d’assurance maladie : fichier de référence de la sécurité sociale du {gkv}.",
  },
  onboarding: {
    actions: { add: 'Ajouter', back: 'Retour', next: 'Suivant', remove: 'Retirer' },
    modules: {
      ats: 'Recrutement',
      time_tracking: 'Temps',
      apprenticeship: 'Ausbildung',
    },
    fork: {
      // The headline is two keys: the lead and `titleMark`, the final beat that sits
      // on the highlighter stroke. The mark is always the LAST beat of the sentence.
      eyebrow: 'Bienvenue chez lumi',
      title: 'Quel plaisir de vous',
      titleMark: 'voir ici.',
      subtitle: 'Comment souhaitez-vous commencer ? Vous pouvez changer à tout moment.',
      // From a live demo the same page is the way out of it.
      eyebrowDemo: 'Quitter la démo',
      titleDemo: 'Assez essayé.',
      titleDemoMark: 'Maintenant, pour de vrai.',
      subtitleDemo: 'Avec la configuration guidée, l’entreprise de démonstration reste là jusqu’à ce que vous ayez terminé.',
      reassure: 'Un doute ? Commencez par la démo – vous passez à la vraie configuration quand vous voulez.',
      seedFailed: 'La préparation des données de démonstration n’a pas abouti. Veuillez réessayer.',
      seedFailedNotEmpty:
        'La démo nécessite des modules vides, mais l’un des vôtres contient déjà des données. Supprimez-les d’abord, ou choisissez « Configurer votre suite ».',
      // #364 F19: why the fork opened mid-Finish. The wizard hands an admin back
      // here when the AVV is still unsigned; landing with nothing said is what
      // made a refused Finish read as a silent drop.
      avvRequiredNotice:
        'La configuration ne peut pas être terminée tant que l’accord de sous-traitance (AVV) n’est pas accepté. Acceptez-le ici et vous revenez directement à l’assistant de configuration.',
      // #364 F21 / ADR 0032 Decision 2: the fork is now also reached FROM a live
      // demo, so it needs the wizard's way out. Leaving costs nothing.
      backToDemo: 'Retour à la démo',
      demo: {
        eyebrow: 'Essayer',
        title: 'Explorer avec des données de démonstration',
        body: 'Nous remplissons vos modules avec une entreprise fictive cohérente. Parcourez tout à votre guise, sans rien casser.',
        modulesHint: 'Les modules souscrits sont toujours inclus.',
        cta: 'Explorer la démo',
      },
      guided: {
        eyebrow: 'Configurer',
        title: 'Guidez-moi pas à pas',
        body: 'Pas à pas vers votre vraie suite. Faire une pause, ignorer une étape ou passer d’abord par la démo – tout est possible.',
        bodyDemo: 'Pas à pas vers votre vraie suite. Si vous fermez la fenêtre, vous retrouvez la démo.',
        pointSaved: 'Votre progression est enregistrée',
        pointOptional: 'Chaque étape est facultative',
        cta: 'Guidez-moi pas à pas',
      },
      empty: {
        eyebrow: 'À votre façon',
        titleFresh: 'Démarrer à vide',
        titleDemo: 'Supprimer la démo et démarrer à vide',
        bodyFresh: 'Une page blanche. Vous configurez tout peu à peu, à votre rythme.',
        bodyDemo: 'L’entreprise de démonstration est supprimée, vous repartez d’une base vide.',
        warnDemo: 'Cela prend effet immédiatement et ne peut pas être annulé.',
        cta: 'Démarrer à vide',
      },
    },
    exitGate: {
      title: 'Avant de quitter la démo',
      intro: 'Voici ce que votre espace de travail a réservé et où en est votre période d’essai. Ajoutez un module maintenant, ou plus tard depuis la facturation — la configuration fonctionne dans les deux cas.',
      booked: { title: 'Réservé' },
      // The colleagues invited from the demo bar, named before the owner ends the demo
      // (issue 669); `fallback` stands in when the roster could not be read.
      guests: {
        title: 'Collègues invités à la démo',
        lead: 'Ces collègues perdent leur accès à la fin de la démo :',
        fallback: 'Les collègues que vous avez invités à la démo perdent leur accès lorsqu’elle prend fin.',
        people: 'Votre véritable équipe est invitée depuis Personnel une fois votre espace de travail configuré.',
      },
      // What only the gate can say about a module booked at it (#409 F12): whether
      // its setup-guide section is there yet. The booking rows themselves are the
      // billing section's.
      bookedHere: {
        settingUp: 'Mise en place de {module}…',
        booked: '{module} est réservé et dispose de sa propre section dans le guide de configuration.',
        bookedPending: '{module} est réservé. Sa section apparaîtra dans le guide de configuration dès que le module sera prêt.',
      },
      noManage: 'Seuls le propriétaire de l’espace de travail, un responsable de facturation ou un administrateur de l’espace peuvent réserver des modules. Vous pouvez tout de même continuer sans réserver.',
      enforcement: 'Un paiement est en attente sur cet espace de travail. Les réservations sont suspendues jusqu’à son règlement — pas la configuration de votre suite.',
      factsUnavailable: 'Impossible de charger votre réservation pour le moment. Vous pouvez tout de même continuer ; tout se trouve sur la page Facturation.',
      trial: {
        title: 'Votre période d’essai',
        range: 'Votre période d’essai a commencé le {start} et se termine le {end}.',
        endOnly: 'Votre période d’essai se termine le {end}.',
        rangeFree: 'Gratuit du {start} au {end}.',
        endOnlyFree: 'Gratuit jusqu’au {end}.',
        charge: 'À partir du {end}, {amount} par mois sont facturés pour votre réservation, au début de chaque mois de facturation.',
        chargeNoTotal: 'À partir du {end}, votre réservation est facturée chaque mois, au début de chaque mois de facturation.',
        firstCharge: 'Le premier prélèvement a lieu le {date}.',
        demoCounted: 'Le temps passé dans la démo a compté dans votre période d’essai.',
        over: 'Votre période d’essai est terminée et votre réservation est facturée chaque mois.',
        monthly: 'Soit {amount} par mois.',
        nextCharge: 'Le prochain prélèvement a lieu le {date}.',
      },
      continue: 'Continuer vers la configuration',
    },
    avv: {
      modalTitle: 'Accepter l’accord de sous-traitance (AVV)',
      modalBody:
        'Configurer votre suite avec des données réelles signifie que lumi traite des données personnelles pour votre compte. Avant de continuer, veuillez lire et accepter notre accord de sous-traitance (AVV) actuel.',
      modalLinkText: 'Lire l’AVV complet',
      modalCheckboxLabel: 'J’ai lu et j’accepte l’AVV actuel.',
      modalCancel: 'Pas maintenant',
      modalAccept: 'Accepter et continuer',
    },
    preparing: {
      first: {
        title: 'Votre démo est en cours de préparation.',
        body: 'Nous créons une entreprise fictive cohérente dans tous vos modules. Cela ne prend qu’un instant.',
      },
      reset: {
        title: 'Votre démo est en cours de réinitialisation.',
        body: 'Nous vidons l’entreprise de démonstration et la reconstruisons de zéro. Votre espace de travail et vos collègues ne sont pas concernés. Cela ne prend qu’un instant.',
      },
      stuck: {
        note: 'Cela prend plus de temps que prévu.',
        cta: 'Configurer manuellement',
      },
    },
    nonAdmin: {
      title: 'Presque',
      titleMark: 'terminé.',
      body: 'Votre administratrice ou votre administrateur termine encore la configuration de la suite. Dès que ce sera fait, vous entrerez directement ici.',
    },
    wizard: {
      title: 'Configurer votre suite',
      subtitle: 'Tout est facultatif ici et votre progression est enregistrée. Configurez ce que vous voulez, terminez la configuration ou revenez à la démo en fermant cette fenêtre.',
      subtitleCommitting: 'Votre configuration est en cours d’application. Si une étape échoue, vous pouvez l’ignorer et la configurer plus tard dans les paramètres.',
      crossRef: 'Utilisé dans {modules} — modifiable plus tard dans {owner}.',
      crossRefOwnerDefault: 'Personnel',
      recovery: '« {step} » n’a pas pu être appliqué. Vérifiez vos saisies à cet endroit, puis terminez à nouveau.',
      details: {
        step: 'Vos informations',
        title: 'Vos informations',
        subtitle: 'Votre propre fiche dans Personnel. Vérifiez votre nom : en l’enregistrant, vous confirmez votre fiche.',
        loading: 'Chargement de votre fiche…',
        confirmed: 'Votre fiche est confirmée au nom de {name}. Vous pourrez la modifier plus tard dans Personnel.',
        unavailable: 'Votre fiche n’a pas pu être chargée pour le moment. Vous pourrez la confirmer plus tard dans Personnel.',
        firstName: 'Prénom',
        lastName: 'Nom',
        required: 'Saisissez votre prénom et votre nom.',
        hq: {
          title: 'Votre siège',
          why: 'Lumi ne peut pas se passer d\'un site : il a besoin de votre siège comme premier site, par exemple pour vos offres d\'emploi.',
          street: 'Rue',
          postalCode: 'Code postal',
          city: 'Ville',
          country: 'Pays',
          countryNone: 'Aucun pays sélectionné',
          required: 'Saisissez la rue, le code postal, la ville et le pays de votre siège.',
        },
      },
      general: {
        title: 'Général',
        company: {
          title: 'Profil de l’entreprise',
        },
        name: {
          label: 'Nom de l’entreprise',
          hint: 'Prérempli depuis la commande — modifiez si besoin. Obligatoire.',
          required: 'Le nom de l’entreprise est obligatoire.',
        },
        profile: {
          industry: 'Secteur',
          employeeCountRange: 'Taille de l’entreprise',
          employeeCountPlaceholder: 'p. ex. 50–200',
          foundedYear: 'Fondée en',
          foundedYearPlaceholder: 'p. ex. 2010',
          legalForm: 'Forme juridique',
          websiteUrl: 'Site web',
        },
        place: {
          hint: 'Choisissez une ville dans la liste comme nom du site — ou saisissez un nom de votre choix et validez avec Entrée ou +.',
        },
        org: {
          title: 'Structure de l’organisation',
          subtitle: 'Les départements, sites et centres de coûts auxquels appartiennent vos collaborateurs.',
          departments: 'Départements',
          locations: 'Sites',
          costCenters: 'Centres de coûts',
          empty: 'Aucun pour l’instant',
          addDepartment: 'Nouveau département',
          addLocation: 'Nouveau site, p. ex. Paris',
          addCostCenter: 'Nouveau centre de coûts',
        },
      },
      finish: {
        cta: 'Terminer la configuration',
        step: 'Fin',
        title: 'Terminer votre configuration',
        body: 'Terminer applique vos réponses. Vous pourrez tout modifier plus tard dans chaque module.',
        nextTitle: 'Ensuite : invitez votre équipe',
        nextBody: 'Après la configuration, ouvrez l’espace d’administration pour inviter les premiers utilisateurs et attribuer leurs rôles.',
        demoWarning: 'Terminer efface l’entreprise de démonstration et tous les utilisateurs invités pendant son exploration.',
      },
      sections: {
        ats: {
          title: 'Recrutement',
          subtitle: 'Configurez le fonctionnement des candidatures et des e-mails de recrutement.',
          fields: {
            fromName: { label: 'Nom de l’expéditeur', hint: 'Affiché sur les e-mails aux candidats.' },
            signature: { label: 'Signature d’e-mail', hint: 'Ajoutée aux e-mails sortants aux candidats.' },
          },
          jobPosting: {
            title: 'Offre d’emploi',
            hint: 'Le contact de candidature et le logo affichés sur les offres d’emploi externes (facultatif — vous pouvez aussi le configurer plus tard).',
            contactName: 'Nom du contact',
            contactEmail: 'E-mail de contact',
            logo: 'Logo de l’offre',
            uploadLogo: 'Téléverser le logo',
            removeLogo: 'Retirer',
            rePick: 'Votre logo n’a pas encore été téléversé — sélectionnez-le à nouveau.',
            contactEmailInvalid: 'Veuillez saisir une adresse e-mail valide.',
          },
          workflow: {
            title: 'Processus de recrutement',
            participantsQuestion: 'Qui est impliqué dans les offres d’emploi et les candidatures ?',
            worksCouncil: 'Comité social et économique',
            sbv: 'Représentation des salariés en situation de handicap',
            legalSignOff: 'Service juridique – valide une offre d’emploi avant sa publication',
            assessmentCentreQuestion: 'Utilisez-vous des centres d’évaluation ?',
            assessmentCentre: 'Oui, nous utilisons des centres d’évaluation',
            hint: 'Vous pouvez modifier et mettre à jour ce processus à tout moment dans l’ATS.',
          },
        },
        time_tracking: {
          title: 'Temps',
          subtitle: 'Types de saisie et règles de temps de travail.',
          fields: {
            bookingTypes: { label: 'Types de saisie', hint: 'Ajoutez les types de saisie que vous utilisez.', placeholder: 'p. ex. Travail' },
          },
          companyHolidays: {
            title: 'Fermetures d’entreprise',
            hint: 'Jours où l’entreprise est fermée – par exemple une demi-journée le 24 et le 31 décembre. Aucune heure théorique n’est due ces jours-là. Pour chaque entrée, vous décidez si elle est déduite des congés ; vous pourrez le modifier plus tard dans les paramètres de Temps.',
            empty: 'Aucune fermeture d’entreprise saisie pour l’instant.',
            suggestions: 'Suggestions :',
            christmasEve: 'Veille de Noël',
            newYearsEve: 'Saint-Sylvestre',
            name: 'Intitulé',
            namePlaceholder: 'p. ex. Entre Noël et le Nouvel An',
            from: 'Du',
            to: 'Au (facultatif)',
            halfDay: 'Demi-journée',
            yearly: 'Chaque année',
            deductsFromLeave: 'Déduire des congés',
            rangeReversed: 'La date de fin précède la date de début.',
          },
        },
        apprenticeship: {
          title: 'Ausbildung',
          subtitle: 'Métiers de formation.',
          fields: {
            professions: { label: 'Métiers de formation', hint: 'Les métiers d’apprentissage que vous formez.', placeholder: 'p. ex. Informaticien/ne' },
          },
        },
        people: {
          title: 'Personnel',
          subtitle: 'Vocabulaire commun utilisé dans toute la suite.',
          fields: {
            salutations: { label: 'Civilités', hint: 'Ajoutez des civilités en plus de l’ensemble standard.', placeholder: 'p. ex. Mx' },
            contractTypes: { label: 'Types de contrat', hint: 'Ajoutez des types de contrat en plus de l’ensemble standard.', placeholder: 'p. ex. Étudiant salarié' },
            workTimeModels: { label: 'Modèles de temps de travail', hint: 'Ajoutez des modèles en plus de l’ensemble standard.', placeholder: 'p. ex. Partage de poste' },
            workLocationTypes: { label: 'Lieux de travail', hint: 'Ajoutez des types de lieu de travail en plus de l’ensemble standard.', placeholder: 'p. ex. Service extérieur' },
          },
        },
      },
    },
    commit: {
      wiping: {
        title: 'Suppression de la démo…',
        body: 'Suppression de l’entreprise de démonstration pour que votre configuration réelle démarre proprement.',
      },
      applying: {
        title: 'Configuration de votre suite…',
        body: 'Application de vos réponses. Cela ne prend qu’un instant.',
      },
      steps: {
        company: 'Profil de l’entreprise',
      },
      error: 'Une erreur s’est produite lors de l’application de votre configuration.',
      retry: 'Réessayer',
      backToSetup: 'Retour à la configuration',
      skipStep: 'Terminer sans cette étape',
      skipped: 'Ignoré : {steps}. Vous pourrez le configurer à tout moment dans les paramètres.',
      resume: 'Reprendre la configuration',
      stalled: 'Cela prend plus de temps que prévu.',
      wipeFailed: 'La démo n’a pas pu être supprimée. Réessayez pour continuer.',
      logoMissing: 'Votre logo n’a pas été téléversé (perdu au rechargement) — vous pourrez l’ajouter plus tard dans les paramètres des offres d’emploi.',
      workflowFailed: 'Votre chaîne de recrutement n’a pas pu être générée : votre espace de travail démarre donc sur la chaîne standard. Tout le reste a été appliqué — ouvrez les paramètres de workflow dans Recrutement pour relancer le générateur.',
      workflowDrafted: 'Votre processus de recrutement a été enregistré comme brouillon car {roles} n’a encore personne d’assigné. Ouvrez les paramètres de workflow dans Recrutement pour l’activer une fois le rôle pourvu.',
      workflowRoles: {
        ats_works_council: 'le comité social et économique',
        ats_sbv: 'la représentation des travailleurs handicapés',
        ats_legal: 'le service juridique',
      },
      continue: 'Continuer vers l’espace de travail',
    },
  },
  tenants: {
    switcherLabel: 'Changer d’espace de travail',
    supportAccessBadge: 'Support',
    supportAccessUntil: 'Accès temporaire du support jusqu’au {until}',
    supportAccessBanner: 'Le support lumi dispose actuellement d’un accès temporaire à cet espace.',
    supportAccessReview: 'Examiner',
  },
  dataProtection: {
    blockedErasure: {
      title: 'Ce qui bloque une suppression',
      intro: 'Les documents du dossier du personnel sans durée de conservation sont conservés sans limite : personne n’a décidé combien de temps ils doivent être conservés, et un document non tranché n’est jamais supprimé automatiquement. Vous les trouvez ici afin de pouvoir fixer ces durées.',
      sensitivePlaceholder: 'Document sensible',
      categories: {
        contract: 'Contrat',
        contract_amendment: 'Avenant au contrat',
        certificate: 'Certificat',
        attestation: 'Attestation',
        warning: 'Avertissement',
        other: 'Autre document',
      },
      outcomes: {
        refused: 'Suppression refusée',
        partial: 'Partiellement supprimé',
      },
      list: {
        title: 'Documents sans durée de conservation',
        fixHint: 'Les plus anciens apparaissent en premier. Indiquez une durée de conservation sur le document dans le dossier du personnel pour le retirer de cette liste.',
        loading: 'Chargement des documents…',
        loadError: 'La liste n’a pas pu être chargée. Veuillez réessayer — ne lisez pas cela comme « aucun résultat ».',
        empty: 'Tous les documents de cet espace de travail ont une durée de conservation.',
        uploadedLabel: 'Téléversé le',
        truncated: 'Seuls les {count} documents les plus anciens sont affichés. D’autres attendent une durée de conservation.',
      },
    },
    myData: {
      title: 'Mes données',
      intro: 'Vous pouvez demander ici quelles données cet espace de travail conserve à votre sujet, en demander la rectification ou l’effacement. Chaque demande est enregistrée et traitée par les personnes chargées de la protection des données dans cet espace, et vous pouvez la suivre ici.',
      requests: {
        title: 'Mes demandes',
        loading: 'Chargement de vos demandes…',
        loadError: 'Vos demandes n’ont pas pu être chargées. Vous pouvez tout de même faire une demande ci-dessous.',
        empty: 'Vous n’avez encore fait aucune demande.',
        filedLabel: 'Déposée le',
        dueLabel: 'Réponse attendue',
        outcomeLabel: 'Résultat',
        awaitingRelease: 'Copie en cours de vérification',
      },
      kinds: {
        access: 'Copie de mes données',
        rectification: 'Rectification',
        erasure: 'Effacement',
      },
      statuses: {
        received: 'Reçue',
        verifying: 'Vérification de votre identité',
        in_progress: 'En cours de traitement',
        awaiting_subject: 'En attente de votre réponse',
        completed: 'Terminée',
        refused: 'Refusée',
        withdrawn: 'Retirée',
      },
      outcomes: {
        erased: 'Données effacées',
        suppressed: 'Données effacées, enregistrement minimal conservé',
        refused: 'Refusée',
        partial: 'Partiellement traitée',
        answered: 'Réponse donnée',
      },
      actions: {
        access: {
          title: 'Demander une copie de mes données',
          body: 'Vous pouvez demander une copie des données que cet espace de travail conserve à votre sujet. Ce n’est pas un téléchargement immédiat : la copie est d’abord constituée, et vous êtes prévenu dès qu’elle est prête.',
          where: 'Une copie prête n’est jamais envoyée en pièce jointe. Vous recevez un e-mail, vous vous connectez à votre compte lumi HR et vous la téléchargez depuis ce compte.',
          cta: 'Demander une copie',
          detailLabel: 'Précision (facultatif)',
          detailHint: 'Par exemple si vous ne souhaitez qu’une partie de vos données.',
        },
        rectification: {
          title: 'Demander une rectification',
          body: 'Si une information que cet espace de travail conserve à votre sujet est inexacte ou obsolète, vous pouvez en demander la rectification.',
          cta: 'Demander une rectification',
          detailLabel: 'Qu’est-ce qui est inexact, et que faut-il indiquer ?',
          detailHint: 'Décrivez les données le plus précisément possible afin qu’elles puissent être retrouvées et vérifiées.',
          selfTitle: 'Vous pouvez modifier une partie vous-même',
          selfFields: 'Votre nom et votre civilité, votre genre, votre e-mail de contact, votre téléphone, votre adresse, votre nationalité, votre situation de famille et votre langue se modifient dans votre profil.',
          selfLink: 'Ouvrir mon profil',
          askBody: 'Pour tout le reste – date de naissance, matricule, données de contrat, de paie ou fiscales, documents – utilisez la demande ci-dessous.',
        },
        erasure: {
          title: 'Demander l’effacement de mes données',
          body: 'Vous pouvez demander à cet espace de travail d’effacer les données qu’il conserve à votre sujet.',
          cta: 'Demander l’effacement',
          confirm: 'Votre demande est examinée par les personnes responsables dans cet espace de travail. Les données qui doivent être conservées en vertu de la loi, ou qui restent nécessaires à votre relation de travail, ne peuvent pas être effacées. Vous êtes informé de ce qui a été effacé et de ce qui est conservé.',
          detailLabel: 'Précision (facultatif)',
          detailHint: 'Par exemple, quelles données vous visez si ce n’est pas l’ensemble.',
        },
      },
      form: {
        submit: 'Envoyer la demande',
        submitting: 'Envoi…',
        cancel: 'Annuler',
        success: 'Votre demande est enregistrée. Vous la retrouvez ci-dessus sous « Mes demandes ».',
        errorGeneric: 'Votre demande n’a pas pu être envoyée. Rien n’a été enregistré : veuillez réessayer.',
        errorRateLimit: 'Vous avez envoyé plusieurs demandes en peu de temps. Veuillez réessayer plus tard.',
      },
    },
    export: {
      title: 'Exporter cet espace de travail',
      intro: 'Vous pouvez télécharger à tout moment une copie complète de tout ce que cet espace de travail conserve, dans un format lisible par machine et sans nous le demander.',
      contents: {
        title: 'Ce que contient ce fichier',
        body: 'L’archive contient les données de toutes les personnes en clair et, avec elles, les clés d’accès actives de cet espace de travail : la clé IA, les liens de calendrier et leurs jetons, ainsi que les identifiants des prestataires connectés. L’archive contient aussi, pour Personnel, Recrutement et Temps, un document HR Open Standards (HR-JSON) — le format commun si vous changez de prestataire.',
        handling: 'Conservez-la avec le même soin que ces clés elles-mêmes. Quiconque obtient le fichier et la phrase secrète obtient tout ce qu’il contient.',
      },
      roleRequired: {
        title: 'Cet export nécessite le rôle « Protection des données »',
        body: 'L’archive contient tous les fichiers conservés dans cet espace de travail — bulletins de paie, certificats médicaux et pièces d’identité compris — à côté des données personnelles de chacun et des clés d’accès actives de cet espace de travail.',
        hint: 'Être propriétaire de l’espace de travail ne suffit plus : la personne qui lance l’export doit aussi détenir le rôle « Protection des données ». Ce rôle s’attribue avec les autres rôles de la suite dans l’administration des utilisateurs, et il peut vous être attribué.',
      },
      start: {
        title: 'Lancer un export',
        body: 'Choisissez une phrase secrète. L’archive est chiffrée avec elle, et elle seule permet de l’ouvrir.',
        passphraseWarning: 'Nous n’enregistrons jamais votre phrase secrète et ne pouvons pas la récupérer. Si vous la perdez, l’archive ne peut plus être ouverte — il n’existe aucune réinitialisation.',
        passphraseLabel: 'Phrase secrète',
        passphraseHint: 'Au moins {min} caractères. Choisissez quelque chose de long que vous pouvez conserver en sécurité.',
        confirmLabel: 'Répétez la phrase secrète',
        submit: 'Lancer l’export',
        submitting: 'Lancement…',
        success: 'L’export a été lancé. Il est préparé en arrière-plan et apparaîtra ci-dessous une fois prêt.',
        errorTooShort: 'La phrase secrète doit compter au moins {min} caractères.',
        errorMismatch: 'Les deux phrases secrètes ne correspondent pas.',
        errorAlreadyRunning: 'Un export de cet espace de travail est déjà en cours. Attendez qu’il se termine avant d’en lancer un autre.',
        errorTooMany: 'Cet espace de travail a lancé pour l’instant le nombre maximal d’exports. Veuillez réessayer plus tard.',
        errorGeneric: 'Nous n’avons pas pu confirmer que l’export a démarré. Consultez la liste ci-dessous avant d’en lancer un autre.',
      },
      list: {
        title: 'Exports de cet espace de travail',
        loading: 'Chargement des exports…',
        loadError: 'Les exports n’ont pas pu être chargés.',
        empty: 'Cet espace de travail n’a pas encore été exporté.',
        linkHint: 'Un lien de téléchargement n’est valable que brièvement. S’il ne fonctionne plus, utilisez à nouveau le bouton.',
        retentionHint: 'Chaque archive est supprimée automatiquement à son expiration — la date est indiquée à côté.',
        startedLabel: 'Lancé',
        expiresLabel: 'Disponible jusqu’au',
        download: 'Télécharger',
        preparing: 'Préparation…',
        downloadError: 'Le téléchargement n’a pas pu être préparé. L’archive n’est peut-être plus là.',
        gone: 'L’archive a été supprimée. Lancez un nouvel export si vous avez besoin d’une autre copie.',
        failedHint: 'Cet export n’est pas allé à son terme. Vous pouvez en lancer un nouveau.',
        runningHint: 'Cet export est encore en préparation.',
      },
      statuses: {
        requested: 'Demandé',
        exporting: 'En préparation',
        exported: 'Prêt',
        failed: 'Échoué',
        expired: 'Supprimé',
      },
    },
    settingsPanel: {
      title: 'Traitement des données',
      body: 'Vous pouvez demander la suppression ou la rectification de vos données, ou en demander une copie, {link}.',
      linkLabel: 'ici',
    },
  },
  // Administration › Data subject requests (issue 789): the DSAR work list.
  dataRequests: {
    forbidden: {
      title: 'Cette liste est réservée au rôle protection des données',
      description: 'Les demandes des personnes concernées sont traitées par le propriétaire de l’espace de travail ou par le titulaire du rôle « Protection des données ».',
    },
    intro: {
      title: 'Demandes des personnes concernées',
      body: 'Les demandes de personnes au sujet des données que cet espace de travail détient sur elles. Chacune doit recevoir une réponse dans un délai d’un mois à compter de sa réception (art. 12, §3 du RGPD). Pour une demande complexe, le délai peut être prolongé deux fois d’un mois — avec un motif communiqué à la personne.',
    },
    filters: {
      label: 'Afficher les demandes',
      open: 'Ouvertes',
      overdue: 'En retard',
      dueSoon: 'À traiter sous 7 jours',
      closed: 'Traitées récemment',
    },
    empty: {
      title: 'Aucune demande de personne concernée',
      description: 'Lorsqu’une personne s’enquiert de ses données — dans lumi, par e-mail, par courrier ou par téléphone — la demande apparaît ici avec son délai.',
    },
    emptyFilter: 'Aucune demande dans cette vue.',
    truncated: 'Toutes les demandes ne tiennent pas sur cette page. Les délais les plus proches sont affichés en premier.',
    badges: {
      overdue: 'En retard',
      dueSoon: 'Échéance proche',
      legalHold: 'Conservation obligatoire',
      reviewReady: 'Prêt pour la vérification',
      reviewReleased: 'Libérée',
      reviewDelivered: 'Remise',
    },
    row: {
      received: 'Reçue le',
      due: 'Réponse due le',
      closed: 'Clôturée le',
      subject: 'Concerne',
      channel: 'Arrivée par',
      outcome: 'Résultat',
      extensions: 'Délai prolongé {count} fois sur 2',
      postponed: 'Rappels suspendus jusqu’au {date}',
      vetoWindow: 'L’effacement peut encore être arrêté jusqu’au {date}',
      reviewFlagged: 'Votre décision est requise : {flagged} entrées sur {total}',
      reviewNoneFlagged: 'Aucune entrée signalée',
      reviewEmpty: 'La copie ne contient aucune entrée',
      reviewOpen: 'Vérifier',
      reviewReleased: 'Libérée, en cours de remise',
      reviewDelivered: 'Remise, clôture en cours',
    },
    legalHold: {
      tenant: 'Une conservation obligatoire s’applique à tout l’espace de travail ({reason}).',
      subject: 'Une conservation obligatoire couvre cette personne ({reason}).',
      consequence: 'Les données ne peuvent pas être effacées. La réponse licite est un refus qui nomme ce fondement — la mesure ne suspend pas le délai.',
    },
    automated: {
      pending: 'lumi répond lui-même à cette demande : une fois l’identité de la personne vérifiée et la demande passée à « En cours de traitement », lumi prépare la copie de ses données. Elle attend ensuite votre vérification. Après votre validation, la personne est informée de l’endroit où la télécharger et la demande se clôture d’elle-même.',
      running: 'lumi prépare la copie des données de cette personne. Elle attend ensuite votre vérification — la personne n’est informée de l’endroit où la télécharger qu’après votre validation.',
    },
    detail: {
      show: 'Voir qui a fait la demande',
      hide: 'Masquer les détails',
      loading: 'Chargement des détails…',
      loadError: 'Les détails de cette demande n’ont pas pu être chargés.',
      subjectLabel: 'Nom indiqué',
      subjectEmail: 'Adresse e-mail',
      subjectPhone: 'Numéro de téléphone',
      requestDetail: 'Ce qui a été demandé',
      onBehalfReason: 'Enregistrée pour son compte parce que',
      extensionReason: 'Motif de la prolongation',
      outcomeBasis: 'Fondement indiqué',
      nothingOnFile: 'Coordonnées',
      nothingOnFileValue: 'Aucun nom, aucune adresse ni aucun message n’est enregistré pour cette demande.',
    },
    kinds: {
      access: 'Copie de ses données',
      rectification: 'Rectification',
      erasure: 'Effacement',
      restriction: 'Limitation du traitement',
      portability: 'Portabilité des données',
      objection: 'Opposition au traitement',
    },
    statuses: {
      received: 'Reçue',
      verifying: 'Identité en cours de vérification',
      in_progress: 'En cours de traitement',
      awaiting_subject: 'En attente de la personne',
      completed: 'Terminée',
      refused: 'Refusée',
      withdrawn: 'Retirée',
    },
    outcomes: {
      erased: 'Données effacées',
      suppressed: 'Données effacées, trace minimale conservée',
      refused: 'Refusée',
      partial: 'Partiellement traitée',
      answered: 'Réponse complète',
    },
    subjectTypes: {
      person: 'Un dossier salarié',
      tenant_user: 'Un membre sans dossier salarié',
      candidate: 'Un candidat',
      unlinked: 'Rattachée à aucun dossier',
    },
    channels: {
      'self-service': 'Déposée dans lumi par la personne',
      'candidate-portal': 'Portail candidats',
      email: 'E-mail',
      post: 'Courrier',
      phone: 'Téléphone',
      unknown: 'Non renseigné',
    },
    actions: {
      advance: {
        verifying: 'Vérifier l’identité',
        in_progress: 'Commencer le traitement',
        awaiting_subject: 'Attendre la personne',
      },
      extend: 'Prolonger le délai',
      close: 'Clôturer la demande',
      postpone: 'Suspendre les rappels',
      veto: 'Ouvrir le délai de veto',
      hold: 'Conserver pour cette personne',
      restrict: 'Limiter le traitement',
      record: 'Enregistrer une demande',
    },
    confirmAutomated: {
      title: 'Préparer la copie des données de cette personne ?',
      body: 'En passant la demande à « En cours de traitement », vous chargez lumi de rassembler tout ce que cet espace de travail détient sur la personne. La copie ne lui est pas encore envoyée : elle attend votre vérification, et la personne n’est informée de l’endroit où la télécharger qu’après votre validation. Ne le faites qu’une fois son identité établie.',
      confirm: 'Commencer',
    },
    toast: {
      advanced: 'Demande passée à « {status} ».',
      extended: 'Délai prolongé jusqu’au {date}.',
      closed: 'Demande clôturée.',
      postponed: 'Rappels suspendus jusqu’au {date}.',
      vetoOpened: 'Délai de veto ouvert. L’effacement attend 72 heures.',
      holdPlaced: 'Conservation obligatoire mise en place.',
      holdReleased: 'Conservation obligatoire levée.',
      holdAttested: 'Conservation obligatoire confirmée pour six mois de plus.',
      restrictionPlaced: 'Traitement limité.',
      restrictionNotified: 'Information enregistrée.',
      restrictionLifted: 'Limitation levée.',
      recorded: 'Demande enregistrée.',
    },
    extend: {
      title: 'Prolonger le délai',
      body: 'L’art. 12, §3 du RGPD permet deux prolongations d’un mois lorsqu’une demande est complexe ou que les demandes sont nombreuses. Informez-en la personne dans le premier mois, avec le motif.',
      remaining: 'Prolongations restantes : {count}',
      reasonLabel: 'Motif du retard',
      reasonHint: 'Enregistré avec la demande. Communiquez le même motif à la personne.',
      submit: 'Prolonger d’un mois',
      errorReason: 'Veuillez indiquer le motif du retard.',
    },
    close: {
      title: 'Clôturer la demande',
      body: 'Une demande clôturée ne peut pas être rouverte : elle est la trace de la manière et de la date auxquelles l’espace de travail a répondu.',
      statusLabel: 'Comment a-t-elle été clôturée ?',
      outcomeLabel: 'Ce qui a été fait',
      outcomePlaceholder: 'Choisir…',
      basisLabel: 'Fondement juridique',
      basisHint: 'Le fondement de ce qui a été conservé ou refusé, par exemple une obligation de conservation ou l’art. 12, §5 du RGPD.',
      submit: 'Clôturer la demande',
      errorOutcome: 'Veuillez choisir ce qui a été fait.',
      errorBasis: 'Un refus ou une réponse partielle doit nommer son fondement juridique.',
      conflict: 'La demande n’a pas pu être clôturée ainsi. Une conservation obligatoire ou une fenêtre de veto ouverte peut empêcher l’effacement des données, ou la demande a changé entre-temps — rechargez la liste et vérifiez.',
    },
    record: {
      title: 'Enregistrer une demande',
      body: 'Pour une demande reçue par e-mail, par courrier ou par téléphone. Le délai d’un mois court à partir du jour de sa réception, pas d’aujourd’hui. Une demande enregistrée commence au statut reçue.',
      choose: 'Choisir…',
      kindLabel: 'Type de demande',
      channelLabel: 'Arrivée par',
      receivedLabel: 'Reçue le',
      receivedHint: 'Le jour où la demande est parvenue à l’espace de travail — au plus tard aujourd’hui.',
      subjectLabel: 'Personne concernée',
      modes: {
        person: 'Une personne dans Personnel',
        candidate: 'Une candidature dans Recrutement',
        unlinked: 'Aucun dossier',
      },
      personLabel: 'Rechercher la personne',
      personHint: 'Recherchez par nom ou adresse e-mail.',
      candidateLabel: 'Candidat ou candidate',
      candidateHint: 'Recherchez par nom ou adresse e-mail. Seuls les candidats que votre rôle dans Recrutement peut ouvrir sont trouvés.',
      candidateRefused: 'Vos rôles dans Recrutement ne permettent pas de rechercher des candidatures. Choisissez « Aucun dossier » et indiquez le nom donné par la personne.',
      searchPlaceholder: 'Nom ou adresse e-mail',
      picker: {
        searching: 'Recherche…',
        typeMore: 'Au moins {count} caractères',
        noMatch: 'Aucun résultat. Si la personne n’est enregistrée nulle part, choisissez « Aucun dossier ».',
        error: 'La recherche a échoué. Si la personne n’est enregistrée nulle part, choisissez « Aucun dossier ».',
        refused: 'Vos rôles ne permettent pas de rechercher des candidatures.',
        rateLimited: 'Trop de recherches – reprise dans un instant',
        resultsAnnouncement: 'Un résultat | {count} résultats',
        clear: 'Effacer la sélection',
      },
      nameLabel: 'Nom indiqué',
      nameHint: 'Tel que la personne a signé ou s’est présentée.',
      emailLabel: 'Adresse e-mail (facultatif)',
      detailLabel: 'Que demande-t-on ?',
      detailHint: 'Facultatif. Autant que possible avec les mots de la personne.',
      reasonLabel: 'Pourquoi l’enregistrez-vous pour son compte ?',
      reasonHint: 'Par exemple : lettre aux RH du 3 mai, ou appel pris à l’accueil. Enregistré avec votre nom.',
      submit: 'Enregistrer la demande',
      errorKind: 'Veuillez choisir le type de demande.',
      errorChannel: 'Veuillez choisir comment la demande est arrivée.',
      errorReceived: 'Veuillez choisir le jour de réception de la demande.',
      errorFuture: 'Une demande ne peut pas arriver dans le futur. Choisissez aujourd’hui ou un jour antérieur.',
      errorPerson: 'Veuillez choisir la personne dans la recherche, ou « Aucun dossier ».',
      errorCandidate: 'Veuillez choisir la candidature dans la recherche, ou « Aucun dossier ».',
      errorName: 'Veuillez indiquer le nom donné par la personne.',
      errorEmail: 'Veuillez saisir une adresse e-mail valide, ou laisser le champ vide.',
      errorReason: 'Veuillez indiquer pourquoi vous enregistrez la demande pour son compte.',
    },
    errors: {
      conflict: 'Cette étape n’est plus possible — la demande a changé entre-temps. Rechargez la liste.',
      notLinked: 'Cette demande n’est rattachée à aucun dossier : il n’y a personne à conserver ou à limiter.',
    },
    progress: {
      title: 'Effacement par module',
      show: 'Afficher l’avancement de l’effacement',
      hide: 'Masquer l’avancement de l’effacement',
      loading: 'Chargement du registre d’effacement…',
      loadError: 'Le registre d’effacement n’a pas pu être chargé.',
      unlinked: 'Cette demande n’est rattachée à aucun dossier, aucun module n’a donc rien effacé pour elle.',
      lastExecuted: 'enregistré le {date}',
      states: {
        done: 'Effacé',
        heldNothing: 'Aucune donnée détenue',
        pending: 'Pas encore enregistré',
        deferred: 'Différé — module désactivé',
      },
      modules: {
        people: 'Personnel',
        ats: 'Candidatures',
        time: 'Temps',
        apprentice: 'Apprentissage',
        payroll: 'Paie',
        privacy: 'Registre de protection des données',
      },
    },
    postpone: {
      title: 'Suspendre les rappels',
      body: 'Arrête les e-mails de rappel jusqu’au jour choisi. Le délai légal ne bouge pas — pour le déplacer, prolongez la demande.',
      untilLabel: 'Suspendre jusqu’au',
      untilHint: 'Au plus tard la date limite de réponse, le {date}.',
      reasonLabel: 'Motif',
      reasonHint: 'Enregistré avec la demande, afin de pouvoir justifier la suspension plus tard.',
      submit: 'Suspendre les rappels',
      errorUntil: 'Veuillez choisir le jour où les rappels reprennent.',
      errorRange: 'Choisissez un jour entre demain et la date limite de réponse.',
      errorReason: 'Veuillez indiquer le motif de la suspension.',
    },
    veto: {
      title: 'Ouvrir le délai de veto ?',
      body: 'Pendant les 72 prochaines heures, l’effacement est retenu : la demande ne peut pas être close comme effacée. Profitez-en pour vérifier si une conservation obligatoire ou un refus est nécessaire. Le délai ne peut pas être fermé plus tôt.',
      confirm: 'Ouvrir le délai de veto',
    },
    holds: {
      title: 'Conservations obligatoires',
      intro: 'Une conservation obligatoire empêche l’effacement des données — par une demande, les règles de conservation ou la suppression de l’espace de travail — jusqu’à sa levée. Chaque conservation doit être confirmée de nouveau tous les six mois.',
      placeTenant: 'Conserver tout l’espace de travail',
      empty: 'Aucune conservation obligatoire active.',
      lapsedNotice: 'Conservations dont la date de confirmation est dépassée : {count}. Elles bloquent toujours l’effacement — confirmez-les ou levez-les.',
      scopeTenant: 'Tout l’espace de travail',
      scopeSubject: 'Une personne',
      lapsed: 'Confirmation en retard',
      placedAt: 'Mise en place le',
      attestationDue: 'À confirmer avant le',
      basis: 'Base légale',
      attest: 'Toujours nécessaire',
      attestConfirm: {
        title: 'Maintenir cette conservation ?',
        body: 'Vous confirmez que le motif de la conservation s’applique toujours. Elle reste en place six mois de plus.',
        confirm: 'Maintenir',
      },
      release: {
        open: 'Lever',
        title: 'Lever la conservation obligatoire',
        warning: 'Dès maintenant, les données protégées par cette conservation peuvent être effacées — par des demandes en cours, les règles de conservation ou la suppression de l’espace de travail. Cette action est irréversible.',
        reasonLabel: 'Pourquoi la conservation n’est-elle plus nécessaire ?',
        reasonHint: 'Enregistré avec votre nom.',
        submit: 'Lever la conservation',
        errorReason: 'Veuillez indiquer le motif de la levée.',
      },
      place: {
        titleTenant: 'Conserver tout l’espace de travail',
        titleSubject: 'Conserver pour cette personne',
        bodyTenant: 'Tant que la conservation est en place, aucune donnée de cet espace de travail ne peut être effacée — ni par des demandes, ni par les règles de conservation, ni par la suppression de l’espace de travail.',
        bodySubject: 'Tant que la conservation est en place, aucune donnée de la personne visée par cette demande ne peut être effacée. Il faut tout de même répondre à la demande dans le délai.',
        reasonLabel: 'Motif',
        reasonHint: 'Par exemple la procédure judiciaire ou la demande d’une autorité qui impose de conserver les données.',
        basisLabel: 'Base légale (facultatif)',
        basisHint: 'Une courte référence, par exemple le texte de loi ou le numéro de dossier.',
        submit: 'Mettre en place',
        errorReason: 'Veuillez indiquer le motif de la conservation.',
      },
      errors: {
        notActive: 'Cette conservation n’est plus active — elle a été modifiée entre-temps. La liste a été rechargée.',
      },
    },
    restrictions: {
      title: 'Limitations du traitement',
      intro: 'Un dossier limité peut être conservé mais pas utilisé (art. 18 RGPD). Avant de lever une limitation, la personne doit en être informée.',
      empty: 'Aucun traitement n’est limité.',
      originSystem: 'Mise en place après un effacement',
      originRequest: 'Issue d’une demande',
      notified: 'Personne informée le {date}',
      notNotified: 'Personne pas encore informée',
      placedAt: 'Limité depuis le {date}',
      notifyOpen: 'Informer la personne',
      notifyAgain: 'Enregistrer une nouvelle information',
      lift: 'Lever la limitation',
      liftConfirm: {
        title: 'Lever la limitation ?',
        body: 'Le dossier peut de nouveau être utilisé comme avant. La personne a été informée.',
        bodySystem: 'Cette limitation a été mise en place automatiquement sur ce qui a été conservé après l’effacement des données de la personne. La lever rend ces enregistrements de nouveau modifiables et utilisables. Ne la levez que si la limitation n’est plus nécessaire.',
        confirm: 'Lever la limitation',
      },
      errors: {
        notActive: 'Cette limitation n’est plus active, ou la personne n’a pas encore été informée. La liste a été rechargée.',
      },
      place: {
        title: 'Limiter le traitement',
        body: 'Le dossier de la personne visée par cette demande est conservé mais ne peut plus être utilisé jusqu’à la levée de la limitation. La limitation est liée à cette demande.',
        reasonLabel: 'Motif',
        reasonHint: 'Par exemple : la personne conteste l’exactitude des données.',
        submit: 'Limiter',
        errorReason: 'Veuillez indiquer le motif de la limitation.',
      },
      notify: {
        title: 'Informer la personne',
        body: 'La personne doit être informée avant la levée de la limitation (art. 18, par. 3, RGPD).',
        modeLabel: 'Comment la personne est-elle informée ?',
        modeSend: 'lumi envoie un e-mail',
        modeManual: 'Déjà informée autrement',
        manualOnly: 'Cette limitation n’est liée à aucune demande, lumi n’a donc pas d’adresse. Informez la personne vous-même et enregistrez-le ici.',
        employerLabel: 'Employeur nommé dans l’e-mail',
        employerHint: 'La personne doit pouvoir voir qui a limité ses données.',
        refLabel: 'Référence',
        refHint: 'Comment vous l’avez informée, par exemple « courrier du 3 mai » ou un numéro de dossier.',
        dateLabel: 'Informée le',
        dateHint: 'Laisser vide pour aujourd’hui.',
        submitSend: 'Envoyer l’e-mail',
        submitManual: 'Enregistrer l’information',
        sendRefused: 'L’e-mail n’a pas pu être envoyé : la demande ne contient aucune adresse e-mail. Informez la personne autrement et enregistrez-le.',
        errorEmployer: 'Veuillez nommer l’employeur.',
        errorRef: 'Veuillez indiquer une référence pour l’information.',
      },
    },
    review: {
      title: 'Vérifier la copie',
      intro: 'Voici comment la personne lira sa copie. Vous décidez de chaque entrée signalée séparément : la libérer ou la retenir (art. 15, par. 4, RGPD). Le reste est en lecture seule.',
      back: 'Retour aux demandes',
      counter: {
        undecided: '{undecided} entrées sur {flagged} restent à décider',
        allDecided: 'Les {flagged} entrées signalées sont toutes décidées',
        noneFlagged: 'Aucune entrée n’est signalée — vous pouvez libérer la copie tout de suite',
      },
      modules: {
        people: 'Personnel',
        ats: 'Candidatures',
        time: 'Temps',
        apprentice: 'Apprentissage',
      },
      moduleState: {
        notInstalled: 'Ce module ne fait pas partie de cet espace de travail ; rien n’y est conservé.',
        removed: 'Ce module a été retiré de l’espace de travail ; il ne reste rien sur la personne.',
        unavailable: 'Ce module n’était pas joignable lors de la préparation de la copie — ce domaine manque dans la copie. Passez la demande sur « Attendre la personne » puis de nouveau sur « Commencer le traitement » : lumi prépare alors la copie à nouveau — ou libérez-la en connaissance de cause sans ce domaine.',
      },
      moduleEmpty: 'Rien n’est enregistré ici sur la personne.',
      delivered: 'Remise — lumi clôture la demande dans un instant',
      self: {
        title: 'Cette demande vous concerne',
        description: 'Un autre responsable de la protection des données doit vérifier la copie. Vous pouvez répondre à la demande à la main.',
      },
      unverified: 'lumi n’a pas pu vérifier à l’instant si cette demande vous concerne. Veuillez réessayer dans un instant.',
      sectionMeta: 'Traitement : {activity}',
      flagged: 'Signalée',
      flagReason: {
        written: 'Écrite par quelqu’un d’autre à propos de la personne, ou nomme d’autres personnes. Pesez si la personne peut lire cette entrée.',
        generic: 'Peut contenir des informations sur d’autres personnes ou provenir d’autres personnes. Pesez-la au regard de l’art. 15, par. 4, RGPD.',
      },
      state: {
        undecided: 'Pas encore décidée',
        release: 'Sera libérée',
        withhold: 'Sera retenue',
      },
      decision: {
        group: 'Décision sur une entrée de « {section} »',
        release: 'Libérer',
        withhold: 'Retenir',
        changeReason: 'Modifier le motif',
        reasonLabel: 'Motif pour la personne',
        reasonHint: 'La personne lit ce motif dans sa copie. Rédigez-le pour elle et ne reprenez pas le contenu de l’entrée.',
        reasonSave: 'Enregistrer comme retenue',
        reasonRequired: 'Veuillez indiquer un motif.',
        saveError: 'La décision n’a pas pu être enregistrée. L’entrée garde son état précédent.',
      },
      release: {
        action: 'Libérer la copie',
        blocked: 'Décidez d’abord des {undecided} entrées signalées restantes, puis vous pourrez libérer la copie.',
        confirmTitle: 'Libérer la copie ?',
        confirmBody: 'lumi crée maintenant la copie sans les entrées retenues ({withheld}), en informe la personne et clôture la demande.',
        confirmBodyNone: 'lumi crée maintenant la copie, en informe la personne et clôture la demande.',
        confirmLabel: 'Libérer',
        done: 'Libérée — lumi remet la copie',
      },
      errors: {
        undecided: 'Des entrées signalées restent à décider. La page a été rechargée.',
        expired: 'La copie a expiré — lumi en crée une nouvelle, vous la reverrez ici bientôt',
        closed: 'La demande n’est plus ouverte. La copie ne peut plus être libérée.',
      },
      notFound: {
        title: 'Aucune copie n’attend ici',
        description: 'La copie a expiré ou a déjà été remise. Si la demande est encore ouverte, lumi en crée une nouvelle et vous la reverrez bientôt dans la liste.',
      },
    },
  },
  legalNotices: {
    title: 'Information confidentialité et IA pour les salariés',
    intro: 'Ce que cet espace de travail indique à ses propres salariés sur la confidentialité et l’usage de l’IA au travail.',
    titleLabel: 'Titre',
    contentLabel: 'Texte de l’information',
    editMode: 'Modifier',
    previewMode: 'Aperçu',
    followingVersion: 'Suit la version lumi {version}',
    branchedFromVersion: 'Texte propre (dérivé de la version {version} le {date})',
    updateAvailable: 'Une nouvelle version lumi ({version}) est disponible.',
    compareVersions: 'Comparer',
    hideComparison: 'Masquer la comparaison',
    yourText: 'Votre texte',
    lumiVersionHeading: 'Version lumi {version}',
    adoptVersion: 'Adopter la version {version}',
    adoptConfirm: 'Remplacer votre texte dans les deux langues par la version {version} de lumi ?',
    adopted: 'Version de lumi adoptée.',
    saved: 'Enregistré.',
    noticeRequired: 'L’information ne peut pas être enregistrée vide.',
    lumiVersionUnavailable: 'La version actuelle de lumi n’a pas pu être jointe — réessayez sous peu.',
    forbidden: 'Vous n’avez pas accès à cette information.',
    supportRefused: 'Une session de support ne couvre pas cette information.',
    membershipUnavailable: 'Votre accès n’a pas pu être vérifié pour le moment — réessayez sous peu.',
    loadFailed: 'L’information n’a pas pu être chargée.',
    compareUnavailable: 'lumi n’a pas pu être joint, la comparaison et l’adoption ne sont donc pas disponibles pour le moment.',
    blanksOpenRefusal: 'Le texte contient encore des champs à compléter : {list}. Complétez-les ci-dessus, ou remplacez-les par votre propre texte, avant d’enregistrer.',
    unsavedWarning: 'Vous n’avez pas encore enregistré vos modifications de {name}.',
    demoDisclaimer: 'CECI EST LA VERSION DE DÉMONSTRATION D’UNE ENTREPRISE DE DÉMONSTRATION FICTIVE. CE DOCUMENT N’A AUCUNE VALEUR JURIDIQUE.',
    blanks: {
      lead: 'Les modèles de lumi ont besoin de ces informations de votre part. Saisissez chacune une seule fois : elle est insérée dans tous les textes ci-dessous, dans les deux langues.',
      saved: 'Enregistré.',
      complete: 'Toutes les informations requises ont été renseignées.',
      suggested: 'Repris de votre profil d’entreprise – vérifiez-la, puis enregistrez.',
      keys: {
        company_name: { label: 'Nom de l’entreprise', hint: 'La raison sociale de ce workspace, telle qu’elle doit apparaître dans le document.' },
        company_address: { label: 'Adresse de l’entreprise', hint: 'L’adresse postale à laquelle les salariés et les candidats peuvent vous joindre.' },
        privacy_contact: { label: 'Contact protection des données', hint: 'À qui s’adresser pour la protection des données — un nom, une fonction ou une adresse e-mail.' },
        applicant_retention: { label: 'Durée de conservation des données de candidature', hint: 'Combien de temps les candidatures non retenues sont conservées avant suppression.' },
      },
    },
    // The page's two-step checklist (issue 766): the facts form, then the imprint.
    checklist: {
      title: 'Pour que vos textes juridiques soient complets',
      progress: '{done} sur {total} terminé(s)',
      facts: { title: 'Informations pour tous les textes', hint: 'Nom de l’entreprise, adresse, contact protection des données, etc. — insérés dans chaque texte ci-dessous.' },
      imprintAction: 'Saisir les mentions légales',
    },
    candidate: {
      heading: 'Informations pour les candidats',
      intro: 'Les mentions légales que cet espace de travail affiche aux candidats sur le portail carrière.',
      unavailable: 'Les informations pour les candidats ne sont pas disponibles pour le moment.',
      noticeRequired: 'Cette notice est affichée aux candidats et ne peut pas rester vide. Remplacez le texte ou adoptez la version de lumi.',
      imprintRequired: 'Les mentions légales ne peuvent pas être vidées tant que le portail est en ligne. Remplacez le texte au lieu de le supprimer.',
      privacy: {
        title: 'Politique de confidentialité du locataire',
        subtitle: 'Cette version est affichée sur le portail pour les candidats.',
      },
      aiUsage: {
        title: 'Note sur l\'utilisation de l\'IA pour les candidats',
        subtitle: 'Ce texte est affiché aux candidats sur le portail carrière.',
      },
      imprint: {
        title: 'Mentions légales du portail carrière',
        subtitle: 'Ce texte est accessible depuis chaque page du portail.',
        hint: 'Les mentions légales sont obligatoires (§ 5 DDG). Votre portail carrière reste hors ligne tant qu’aucune n’est enregistrée, quelle qu’en soit la langue.',
        fallsBack: 'Vos mentions légales sont enregistrées. Les langues sans mentions légales propres affichent la version {language} sur le portail.',
      },
      history: {
        title: 'Qu’avons-nous affiché à une date donnée ?',
        hint: 'Retrouver le texte exact qui figurait sur cette page à un instant passé — pour la question d\'une personne candidate ou d\'une autorité.',
        open: 'Consulter',
        hide: 'Fermer',
        dateLabel: 'Date et heure',
        localeLabel: 'Langue',
        lookUp: 'Afficher le texte',
        periodClosed: 'En ligne du {from} au {until}.',
        periodOpen: 'En ligne depuis le {from} — toujours le texte actuel.',
        sourceLumi: 'La version {version} publiée par lumi, mot pour mot.',
        sourceLumiUnversioned: 'Le texte publié par lumi.',
        sourceTenant: 'Le texte propre à cet espace de travail, dérivé de la version lumi {version}.',
        sourceTenantOwn: 'Le texte propre à cet espace de travail.',
        none: 'L’enregistrement ne remonte pas jusque-là.',
        provenanceFollowing: 'Ce qui est établi : cette page est une copie de la version lumi {version} et personne ici ne l’a réécrite.',
        provenanceBranched: 'Ce qui est établi : cette page provient de la version lumi {version} et a été réécrite le {date}.',
        provenanceUnknown: 'Rien d’autre n’est enregistré sur cette page pour la période antérieure.',
        futureRefused: 'Cet enregistrement dit ce qu’une page a affiché, pas ce qu’elle affichera. Choisissez un instant déjà passé.',
        invalidRefused: 'Choisissez une date et une langue pour la consultation.',
        failed: 'L’enregistrement n’a pas pu être lu pour le moment. Veuillez réessayer.',
      },
    },
  },
  legalNoticePublic: {
    unavailable: 'Cette information n’est pas disponible pour le moment.',
  },
  dataImportHub: {
    nav: 'Import de données',
    title: 'Import & export de données',
    intro: 'Importez et exportez les données existantes vers les modules depuis un seul endroit. Chaque action s’exécute dans le module cible sous votre permission.',
    locked: 'Aucune permission dans ce module',
    lockedDetail: 'La permission d’import (data_import.manage) vous manque dans {module}. Demandez à un admin du module.',
    plan: {
      title: 'Plan d’import',
      run: 'Créer les valeurs manquantes',
      summary: '{count} valeurs manquent dans {module} et peuvent y être créées via un import.',
      truncated: 'Liste tronquée — jusqu’à 200 valeurs manquantes par champ.',
      forbidden: 'La permission vous manque dans {module}.',
      running: 'Import compagnon en cours…',
      waiting: 'En attente de la reprise des nouvelles valeurs dans le module cible…',
      rerunning: 'Relance de l’essai dans le module cible…',
      done: 'Terminé — l’essai utilise les nouvelles valeurs.',
      failed: 'L’import compagnon a échoué.',
      confirmTitle: 'Créer les valeurs manquantes ?',
      confirmBody: '{count} valeurs manquent dans {module}. Les créer maintenant via un import ? L’essai redémarrera automatiquement ensuite.',
      companionErrors: 'L’essai compagnon signale des erreurs — vérifiez dans le module.',
      projectionTimeout: 'La projection vers le module cible prend plus longtemps que prévu — relancez l’essai plus tard.',
    },
    createField: {
      title: 'Créer un champ personnalisé',
      intro: 'Créez un champ personnalisé pour la colonne « {column} ». Il sera ensuite disponible partout dans l’ATS.',
      typeHint: 'Les champs à choix (select/sélection multiple) se créent dans la gestion des champs.',
      sensitiveNotImportable: 'Les champs de catégories particulières (art. 9) sont créés mais ne sont volontairement pas une cible d’import.',
      submit: 'Créer le champ',
      label: 'Libellé',
      keyLabel: 'Clé du champ (Key)',
      keyHint: 'Lettres minuscules, chiffres et tirets bas uniquement',
      typeLabel: 'Type',
      types: {
        text: 'Texte',
        textarea: 'Zone de texte',
        number: 'Nombre',
        date: 'Date',
        checkbox: 'Case à cocher',
      },
      sensitivityLabel: 'Quel type de données ce champ contient-il ?',
      sensitivityUnanswered: 'Veuillez choisir',
      sensitivityNone: 'Aucune catégorie particulière',
      sensitivityHint: 'Les données sensibles (art. 9 RGPD) ne peuvent pas déclencher de décision automatisée sur une candidature.',
      sensitivityCategories: {
        racialEthnic: 'Origine raciale ou ethnique',
        politicalOpinion: 'Opinions politiques',
        religiousPhilosophical: 'Convictions religieuses ou philosophiques',
        tradeUnion: 'Appartenance syndicale',
        genetic: 'Données génétiques',
        biometricId: 'Identification biométrique',
        health: 'Données de santé',
        sexLifeOrientation: 'Vie sexuelle ou orientation sexuelle',
      },
      sensitivityRequired: 'Veuillez indiquer quel type de données ce champ contient.',
    },
    entities: {
      person: 'Collaborateurs',
      orgUnit: 'Unités org.',
      employmentContract: 'Contrats',
      job: 'Postes',
      candidate: 'Candidat·es',
      application: 'Candidatures',
      client: 'Clientèle',
      project: 'Projets',
      timeEntry: 'Saisies de temps',
      leaveRequest: 'Absences',
    },
    // People's enum values in the words People uses for them (people-ui's own
    // labels): the import wizard names allowed values with these.
    peopleValues: {
      contractType: {
        permanent: 'CDI (durée indéterminée)',
        fixed_term: 'CDD (durée déterminée)',
        mini_job: 'mini-job',
        midi_job: 'midi-job (zone de transition)',
        working_student: 'étudiant salarié',
        apprenticeship: 'apprentissage',
        internship: 'stage',
        freelance: 'freelance / honoraires',
        managing_director: 'gérant / membre du directoire',
        other: 'autre',
      },
      workTimeArrangement: {
        full_time: 'temps plein',
        part_time: 'temps partiel',
        marginal: 'marginal (mini-job)',
        variable: 'variable / flexible',
      },
      status: {
        draft: 'Brouillon',
        active: 'Actif',
        on_hold: 'En pause',
        terminated: 'Résilié',
        inactive: 'Inactif',
      },
      type: {
        department: 'Service',
        location: 'Site',
        team: 'Équipe',
        cost_center: 'Centre de coûts',
      },
    },
    // People's import fields in People's own words (people-ui's labels), per
    // entity: the wizard's row errors name a field with these, never by its key.
    peopleFields: {
      orgUnit: {
        externalId: 'ID externe',
        type: 'Type',
        name: 'Nom',
        code: 'Code',
        description: 'Description',
        parentExternalId: 'Unité parente',
        parentCode: 'Unité parente (Code)',
        addressLine1: 'Adresse',
        postalCode: 'Code postal',
        city: 'Ville',
        country: 'Pays',
        active: 'Actif',
      },
      person: {
        externalId: 'ID externe',
        employeeNumber: 'Matricule',
        firstName: 'Prénom',
        lastName: 'Nom',
        salutation: 'Civilité',
        gender: 'Genre',
        email: 'E-mail',
        phone: 'Téléphone',
        birthDate: 'Date de naissance',
        nationality: 'Nationalité',
        maritalStatus: 'Situation familiale',
        addressLine1: 'Adresse',
        addressLine2: 'Complément d\'adresse',
        postalCode: 'Code postal',
        city: 'Ville',
        country: 'Pays',
        workCountry: 'Lieu de travail (pays)',
        primaryLocale: 'Langue',
        status: 'Statut',
        primaryOrgUnitExternalId: 'Service / unité',
        primaryOrgUnitCode: 'Service / unité (Code)',
        supervisorExternalId: 'Responsable fonctionnel',
      },
      employmentContract: {
        externalId: 'ID externe',
        personExternalId: 'Personne',
        contractReference: 'Numéro de contrat',
        status: 'Statut du contrat',
        startDate: 'Date d\'entrée',
        endDate: 'Date de sortie',
        probationEndDate: 'Fin de période d\'essai',
        contractType: 'Type de contrat',
        position: 'Poste / fonction',
        primaryOrgUnitExternalId: 'Service / unité',
        supervisorExternalId: 'Responsable hiérarchique',
        workTimeArrangement: 'Temps de travail',
        weeklyHours: 'Heures hebdomadaires',
        vacationDaysPerYear: 'Congés (jours/an)',
        collectiveAgreementCode: 'Convention collective',
      },
    },
  },
  // ── Tenant administration (#432): the five pages that used to be their own
  //     app. Merged verbatim from its catalogue, so the strings are unchanged.
  audit: {
    title: 'Audit Log', subtitle: 'Who did what in your workspace.',
    noAccess: 'No access', noAccessHint: 'You need the audit log permission to view this page.',
    empty: 'No audit events yet', emptyHint: 'Actions in your workspace will appear here.',
    loading: 'Loading…', loadMore: 'Load more',
    filters: { from: 'From', to: 'To', action: 'Action', category: 'Category', actor: 'Actor', outcome: 'Outcome', search: 'Search', searchHint: 'Subject or actor…', apply: 'Apply', reset: 'Reset', all: 'All', actorType: 'Type d’acteur' },
    columns: { time: 'Time', actor: 'Actor', action: 'Action', subject: 'Subject', outcome: 'Outcome' },
    outcome: { success: 'Success', denied: 'Denied', failure: 'Failure' },
    actorType: { user: 'User', system_admin: 'System Admin', support: 'Support', service: 'Service', system: 'System' },
    categories: { auth: 'Auth', access: 'Access', data: 'Data', admin: 'Admin', lifecycle: 'Lifecycle', export: 'Export', security: 'Security' },
    export: { csv: 'Export CSV', ndjson: 'Export NDJSON' },
    detail: { roles: 'Rôles', action: 'Action', actorId: 'Actor ID', onBehalfOf: 'On behalf of', ip: 'IP address', source: 'Source', correlationId: 'Correlation ID', changes: 'Changes', before: 'Before', after: 'After', details: 'Details' },
    actions: { login: { succeeded: 'Login succeeded', failed: 'Login failed', attempts_flagged: 'Tentatives de connexion échouées répétées', locked: 'Compte verrouillé' }, sso: { login_succeeded: 'SSO login succeeded', connection_changed: 'SSO connection changed' }, password: { reset_requested: 'Password reset requested', reset_completed: 'Password reset completed' }, refresh_token: { revoked: 'Session revoked' }, user: { signed_up: 'User signed up', unlocked: 'Compte déverrouillé', disabled: 'Compte désactivé', enabled: 'Compte activé', closed: 'Compte fermé' }, passkey: { revoked: 'Clés d’accès supprimées par un administrateur' }, role: { changed: 'Role changed' }, module_access: { changed: 'Module access changed' }, access: { ownership_transferred: 'Propriété transférée', member_removed: 'Membre supprimé', suite_roles_changed: 'Rôles Suite modifiés' }, tenant: { created: 'Tenant créé', lifecycle: 'Tenant lifecycle change', exported: 'Tenant exporté' }, module: { activated: 'Module activated', deactivated: 'Module deactivated' }, plan: { changed: 'Plan changed' }, tenant_ai_settings: { changed: 'Paramètres d’IA modifiés' }, tenant_role_editing: { changed: 'Modification des rôles changée' }, settings: { changed: 'Settings changed' }, test_data: { seeded: 'Test data seeded', reset: 'Test data reset' }, onboarding: { setup_chosen: 'Configuration choisie', demo_started: 'Mode démo démarré', demo_seeded: 'Données de démo créées', demo_seed_failed: 'Échec de la création des données de démo', demo_wipe_started: 'Suppression de la démo démarrée', demo_wiped: 'Données de démo supprimées', demo_wipe_failed: 'Échec de la suppression des données de démo', setup_finished: 'Configuration terminée', demo_denied: 'Mode démo refusé', module_topup: 'Données de démo ajoutées pour le nouveau module', demo_reset_started: 'Réinitialisation de la démo démarrée', demo_tier_switch_started: 'Passage à la démo complète démarré', demo_rebuilt: 'Démo reconstruite' }, company_profile: { created: 'Profil d’entreprise créé', updated: 'Profil d’entreprise mis à jour' }, org_scenario: { activated: 'Scénario d’organisation activé' }, people_data: { wiped: 'Données RH supprimées' }, ats_data: { wiped: 'Données de recrutement supprimées' }, time_data: { wiped: 'Données de suivi du temps supprimées' }, apprentice_data: { wiped: 'Données d’apprentissage supprimées' }, audit_log: { exported: 'Audit log exported' }, billing_charge: { paid: 'Paiement débité', failed: 'Paiement échoué', refunded: 'Paiement remboursé', chargeback: 'Rétrofacturation reçue' }, invoice: { issued: 'Facture émise' }, mandate: { created: 'Carte ajoutée', replaced: 'Carte remplacée' }, promo_code: { redeemed: 'Code promo utilisé' }, billing_account: { converted: 'Essai converti en abonnement', delinquent: 'Compte en défaut', purged: 'Données de facturation purgées' }, dunning_case: { opened: 'Recouvrement lancé' }, enforcement: { opened: 'Application démarrée', advanced: 'Application escaladée', cleared: 'Application levée' }, billing_exempt: { changed: 'Exonération de facturation modifiée' }, billing_data: { wiped: 'Données de facturation effacées', generated: 'Données de facturation de test générées' }, checkout: { completed: 'Commande finalisée', denied: 'Commande refusée' }, job: { created: 'Poste créé', updated: 'Poste mis à jour', submitted: 'Poste soumis', archived: 'Poste archivé', deleted: 'Poste supprimé' }, application: { created: 'Candidature reçue', updated: 'Candidature mise à jour', transitioned: 'Statut de la candidature modifié', withdrawn: 'Candidature retirée', transferred: 'Candidature transférée vers une autre offre', transfer_declined: 'Transfert de candidature refusé', rejected: 'Candidature rejetée', deleted: 'Candidature supprimée', emailed: 'E-mail de candidature envoyé' }, interview: { proposed: 'Entretien proposé', confirmed: 'Entretien confirmé', cancelled: 'Entretien annulé' }, candidate: { anonymized: 'Candidat anonymisé', emailed: 'E-mail au candidat envoyé', identity_changed: 'Coordonnées du candidat modifiées', identity_split: 'Candidat séparé sur sa propre fiche', identity_merged: 'Candidature rattachée au candidat ayant cette adresse' }, candidate_dossier: { accessed: 'Le candidat a consulté ses données' }, workflow: { deleted: 'Workflow supprimé', definition: { published: 'Workflow publié' } }, task: { blocking_overridden: 'Tâche bloquante outrepassée', auto_cancelled: 'Tâche annulée automatiquement' }, support_access: { requested: 'Accès support demandé', approved: 'Accès support approuvé', denied: 'Accès support refusé', revoked: 'Accès support terminé', expired: 'Accès support expiré', request_expired: 'Demande d’accès support expirée' }, ai_action: { executed: 'Action IA exécutée' }, assistant_run: { proposed: 'lumi a proposé une action', approved: 'Action lumi approuvée', refused: 'Action lumi refusée', failed: 'Échec de l\'action lumi' }, assistant_turn: { fanned_out: 'Requête lumi répartie sur plusieurs modules' }, payroll_export_run: { created: 'Export de paie lancé', completed: 'Export de paie terminé', failed: 'Export de paie en échec', downloaded: 'Export de paie téléchargé' }, payroll_period: { closed: 'Mois de paie clôturé', reopened: 'Mois de paie rouvert' }, payroll_connection: { updated: 'Connexion de paie modifiée' }, payroll_master_data: { exported: 'Données de paie exportées' }, wage_type: { created: 'Rubrique de paie créée', updated: 'Rubrique de paie modifiée', deleted: 'Rubrique de paie supprimée', starter_catalog_applied: 'Rubriques de paie standard ajoutées' }, wage_assignment: { created: 'Élément de rémunération ajouté', updated: 'Élément de rémunération modifié', deleted: 'Élément de rémunération supprimé' }, one_time_payment: { created: 'Paiement ponctuel ajouté', updated: 'Paiement ponctuel modifié', deleted: 'Paiement ponctuel supprimé' }, payslip: { filed: 'Bulletins de paie classés' } },
  },
  sso: {
    title: 'Single Sign-On',
    subtitle: 'Connectez votre fournisseur d\'identité (OIDC) afin que votre équipe se connecte via celui-ci.',
    issuerUrl: 'URL de l\'émetteur (découverte OIDC)',
    clientId: 'Client ID',
    clientSecret: 'Client secret',
    clientSecretKeep: 'Laissez vide pour conserver le secret enregistré',
    label: 'Nom affiché',
    allowedDomains: 'Domaines e-mail autorisés (séparés par des virgules)',
    jitEnabled: 'Créer automatiquement les utilisateurs lors de la première connexion (JIT)',
    jitDefaults: 'Accès aux modules par défaut pour les nouveaux utilisateurs',
    jitModulePlaceholder: 'Choisir un module',
    jitRoles: 'Rôles',
    jitCatalogUnreadable: 'Les rôles de ce module n\'ont pas pu être lus. Les rôles enregistrés restent inchangés.',
    jitUnknownRole: '{key} (inconnu)',
    addJit: 'Ajouter un module',
    remove: 'Remove',
    redirectUri: 'URI de redirection (enregistrez-la dans votre IdP)',
    copy: 'Copier',
    test: 'Tester la connexion',
    testOk: 'Découverte réussie.',
    testFailed: 'Échec du test',
    save: 'Enregistrer',
    saved: 'Enregistré.',
    delete: 'Supprimer la connexion',
    deleteConfirm: 'Supprimer vraiment cette connexion SSO ?',
    enforce: 'Exiger la connexion uniquement via SSO',
    enforceHint: 'La connexion par mot de passe est désactivée pour tout le monde, sauf pour les administrateurs système et le propriétaire de l\'espace de travail.',
    noConnection: 'Aucune connexion SSO configurée pour le moment.',
    deleted: 'Connexion supprimée.',
    enforceEnabled: 'La connexion se fait désormais uniquement via SSO.',
    enforceDisabled: 'La connexion par mot de passe est de nouveau possible.',
    jitNeedsVerifiedDomain: 'Les utilisateurs ne sont créés automatiquement que pour les adresses d’un domaine vérifié.',
    domainsTitle: 'Domaines e-mail',
    domainsIntro: 'Un domaine ne compte pour la connexion SSO qu’une fois que vous avez prouvé qu’il vous appartient : publiez cet enregistrement TXT dans le DNS du domaine, puis vérifiez-le. Les comptes déjà liés continuent de se connecter entre-temps.',
    domainStatus: { pending: 'Non vérifié', verified: 'Vérifié', legacy: 'À vérifier bientôt' },
    domainLegacyUntil: 'À vérifier avant le {date}',
    domainRecordName: 'Nom de l’enregistrement (TXT)',
    domainRecordValue: 'Valeur de l’enregistrement',
    domainVerify: 'Vérifier l’enregistrement',
    domainVerified: '{domain} est vérifié.',
    domainError: { record_not_found: 'Aucun enregistrement TXT trouvé sous ce nom pour l’instant. Les modifications DNS peuvent prendre un moment.', value_mismatch: 'Un enregistrement TXT existe, mais sa valeur ne correspond pas. Copiez la valeur exactement.', dns_error: 'La requête DNS a échoué. Veuillez réessayer dans quelques minutes.' },
  },  users: { seatLimit: { bookMore: 'Les {booked} sièges utilisateur réservés sont tous occupés. Réservez au moins {required} sièges utilisateur pour inviter quelqu’un d’autre.', leaveFreelancer: 'Cet espace de travail est en mode freelance : une personne, un siège. Quitter le mode freelance réserve {required} sièges utilisateur et fait de la place pour les personnes que vous invitez.', notified: 'Les {booked} sièges utilisateur réservés sont tous occupés. Le propriétaire de l’espace de travail et les Billing Managers peuvent réserver d’autres sièges.', cta: 'Réserver plus de sièges' }, removeSuccess: '{email} a été retiré de cet espace de travail.', saveSuccess: 'Modifications d’accès enregistrées pour {email}.', saveFailedFor: 'Impossible d’enregistrer {targets} pour {email} : {reason}', saveFailedOthersSaved: 'Les autres modifications ont été enregistrées.', suiteRolesTarget: 'les rôles de suite', unsaved: 'Non enregistré', defaultRoleHint: 'Rôle par défaut pour les invitations internes', refreshFailed: 'La liste des membres n’a pas pu être actualisée. Rechargez la page pour voir l’état enregistré.', title: 'Utilisateurs & Attributions', email: 'E-mail', suite: 'Suite', suiteSuiteAdmin: 'Admin', suiteSuiteAdminHint: 'Admin de l\'espace de travail : gère les membres, l\'accès aux modules, le SSO et la sécurité.', suiteBillingManager: 'Billing Manager', suiteBillingManagerHint: 'Peut gérer la facturation (factures, carte, forfait).', suiteSupportAgent: 'Support Agent', suiteSupportAgentHint: 'Traite les tickets de support (répondre, escalader, clôturer).', suiteDataProtection: 'Délégué·e à la protection des données', suiteDataProtectionHint: 'Examine et valide les demandes des personnes concernées et les effacements, et peut consulter les données des membres dans chaque module actif.', suiteOwnerLocked: 'Le propriétaire de l\'espace de travail est toujours Admin.', saveFailed: 'Impossible d\'enregistrer l\'attribution', inviteSuccess: '{email} a été invité avec succès', invite: { titleInternal: 'Inviter un membre', titleExternal: 'Inviter en externe', hintInternal: 'Obtient automatiquement le rôle par défaut dans Temps et Personnel – vous pourrez ajouter d’autres rôles juste après l’invitation.', hintExternal: 'Aucun rôle par défaut : sans rôle, cette personne ne peut ouvrir aucun module. Configurez son accès juste après l’invitation.', submit: 'Inviter', sentTitle: 'Invitation envoyée', sentLead: '{email} a été invité(e) et apparaît comme « Invité(e) ».', sentBodyInternal: 'A déjà le rôle par défaut dans Temps et Personnel.', sentBodyExternal: 'Encore sans rôle – configurez ce à quoi cette personne peut accéder.', revoke: 'Retirer l’invitation', moreRoles: 'Autres rôles', setupRoles: 'Configurer les rôles', done: 'Terminé', revokedTitle: 'Invitation retirée', revokedBody: '{email} a été retiré(e) de cet espace de travail. Le lien d’invitation n’est plus valide.' }, removeUser: 'Supprimer', confirmRemove: 'Voulez-vous vraiment supprimer {email} de ce tenant ? Toutes les attributions de modules seront supprimées.', statusActive: 'Actif', statusInvited: 'Invité', statusDisabled: 'Désactivé', transferOwnership: 'Transférer la propriété', transferTitle: 'Transférer la propriété de l’espace de travail', transferIntro: '{from} remet cet espace de travail à {to}. Il n’y a qu’un seul propriétaire : dès la confirmation, {from} ne l’est plus.', transferConsequences: 'Ce qui change :', transferConsequenceBreakGlass: 'La connexion d’urgence en cas de panne du SSO passe à {to} : si votre fournisseur d’identité est indisponible, {to} peut encore se connecter avec un mot de passe, {from} non.', transferConsequenceOutgoing: '{from} conserve tous les rôles déjà détenus, y compris Admin — seule la propriété change de main. {from} peut être désactivé(e) ou supprimé(e) comme n’importe quel autre membre.', transferConsequenceSuiteAdmin: '{to} reçoit le rôle Admin s’il ne l’a pas déjà. Personne ne perd de rôle.', transferSsoWarning: '{email} se connecte via SSO et n’a pas de mot de passe. Si le SSO est indisponible, cette personne ne pourra pas utiliser l’accès d’urgence dont elle hérite ; elle peut définir un mot de passe à tout moment via « Mot de passe oublié ».', transferBlockedPending: '{email} n’a pas encore accepté son invitation. Cela doit être fait avant de pouvoir devenir propriétaire.', transferBlockedDisabled: 'Le compte de {email} est désactivé. Réactivez-le avant de transférer la propriété.', transferConfirmFieldLabel: 'Confirmez le nouveau propriétaire', transferConfirmHint: 'Saisissez {email} pour activer le bouton.', transferSuccess: '{email} est désormais propriétaire de cet espace de travail.', transferFailed: 'La propriété n’a pas pu être transférée. Veuillez réessayer.', transferErrorForbidden: 'Seul le propriétaire actuel peut transférer la propriété.', transferErrorNotMember: '{email} n’est plus membre de cet espace de travail.', transferErrorAlreadyOwner: '{email} est déjà propriétaire de cet espace de travail.', transferErrorRaced: 'La propriété a changé pendant cette transmission. Rechargez la liste et réessayez.', transferErrorIneligible: '{email} ne peut pas reprendre la propriété pour le moment. Actualisez la liste pour voir son statut actuel.', resendInvite: 'Renvoyer l\'invitation', disable: 'Désactiver', enable: 'Activer', confirmDisable: 'Désactiver {email} ? La personne sera déconnectée immédiatement et ne pourra plus se connecter tant que vous n\'aurez pas réactivé le compte.', resendSuccess: 'Invitation renvoyée à {email}.', resendEmailFailed: 'L\'e-mail d\'invitation à {email} n\'a pas pu être envoyé. Veuillez réessayer.', disableSuccess: '{email} a été désactivé.', enableSuccess: '{email} a été activé.', inviteEmailFailed: '{email} a été ajouté, mais l\'e-mail d\'invitation n\'a pas pu être envoyé. Vous pouvez le renvoyer.', searchPlaceholder: 'Rechercher par e-mail', rolesFilterPlaceholder: 'Filtrer par rôle', clearRolesFilter: 'Réinitialiser le filtre', memberCount: '{count} membres', memberCountFiltered: '{shown} sur {count} membres', inviteInternal: 'Inviter', inviteExternal: 'Inviter en externe', removeRoleFilter: 'Retirer le rôle du filtre', columns: { account: 'Compte', status: 'Statut', roles: 'Rôles' },moduleNames: { ats: 'Recrutement', time_tracking: 'Temps', people: 'Personnel', apprenticeship: 'Ausbildung' }, accessDenied: 'Accès refusé', moreActions: 'Plus d’actions pour {email}', noSearchResults: 'Aucun membre ne correspond à « {query} ».', editSubtitle: 'Modifier les rôles et l’accès', suiteConfirmGrantTitle: 'Attribuer un rôle de suite ?', suiteConfirmRevokeTitle: 'Retirer un rôle de suite ?', suiteConfirmMixedTitle: 'Modifier les rôles de suite ?', suiteConfirmLead: 'Voici ce qui change pour {email} :', suiteConfirmRemoved: 'Perd {role}.', suiteConfirmAccept: 'Oui, enregistrer' },
  // The consent page of an agent connection (ADR 0103 rule 10, PDR 0035).
  connectAgent: {
    title: 'Connecter un agent IA',
    heading: 'Un agent IA souhaite agir en votre nom',
    intro: 'Un client IA qui se présente sous le nom « {client} » demande à travailler dans lumi en votre nom, dans l’espace {workspace}.',
    fields: {
      client: 'Se présente comme',
      redirectHost: 'Vous renvoie vers',
      website: 'Site web indiqué',
      workspace: 'Dans l’espace',
    },
    scopesHeading: 'Il demande à :',
    scope: {
      read: 'Lire ce que vous pouvez voir dans lumi',
      act: 'Proposer et exécuter des actions en votre nom — chaque action nécessite votre confirmation',
      ask: 'Poser des questions à lumi',
    },
    meaning: {
      heading: 'Ce que signifie « Autoriser »',
      asYou: 'Il agit en votre nom, avec exactement vos autorisations dans cet espace — jamais davantage.',
      egress: 'Tout ce qu’il lit dans lumi est transmis au fournisseur derrière « {client} », en dehors de lumi.',
      revocable: 'Vous pouvez mettre fin à la connexion à tout moment sur la page de votre compte.',
    },
    standing: {
      label: 'Exécuter les actions sur mes propres données sans me demander à chaque fois',
      hint: 'Ne couvre jamais les données d’autres personnes ni les décisions défavorables — celles-ci demandent toujours. Vous pouvez modifier ce choix à tout moment sur la page de votre compte.',
    },
    rolePins: {
      title: 'Rôle par module',
      hint: 'Là où vous avez plusieurs rôles, choisissez celui dans lequel l’agent travaille. Il ne peut jamais faire plus que ce que ce rôle permet.',
      default: 'Par défaut du module ({rule})',
      defaultRule: {
        first_assigned: 'votre premier rôle attribué',
        first_by_key: 'votre premier rôle selon sa clé',
        all_roles: 'tous vos rôles ensemble',
      },
      modules: {
        ats: 'Recrutement',
        time: 'Temps',
        people: 'Personnel',
      },
      notHeld: 'Vous n’avez plus le rôle choisi dans ce module. Veuillez choisir à nouveau.',
    },
    disabled: {
      title: 'Les agents IA externes sont désactivés dans cet espace',
      body: 'Un propriétaire ou un administrateur peut les activer sous Administration → Agents IA externes. D’ici là, vous pouvez seulement refuser cette demande.',
    },
    actions: {
      allow: 'Autoriser',
      deny: 'Refuser',
    },
    returning: 'Retour vers {client}…',
    invalid: {
      title: 'Cette demande de connexion n’est plus valide',
      hint: 'Relancez la connexion depuis votre client IA.',
    },
  },
  // Administration › External AI agents (ADR 0103 rule 12, PDR 0035 rule 2).
  externalAgents: {
    title: 'Agents IA externes',
    cardTitle: 'Agents IA externes',
    noAccess: 'Aucun accès',
    noAccessHint: 'Seuls le propriétaire de l’espace et les administrateurs de la suite peuvent modifier ce réglage.',
    intro: 'Une fois cette option activée, les membres peuvent connecter leur propre client IA — Claude Code, OpenClaw, … — et le laisser agir en leur nom dans cet espace.',
    points: {
      asMember: 'Un agent travaille avec exactement les autorisations du membre qui l’a connecté — jamais davantage.',
      confirmed: 'Chaque action qu’il propose est confirmée par ce membre avant d’être exécutée.',
      adverse: 'Les décisions défavorables concernant d’autres personnes passent toujours par le panneau lumi ; un agent ne peut jamais les confirmer.',
    },
    egress: {
      title: 'Où vont les données des membres',
      body: 'Tout ce qu’un agent lit est transmis au client IA que le membre connecte — un destinataire hors de la chaîne de sous-traitance de lumi, choisi par votre espace et par le membre.',
      worksCouncil: 'Autoriser ou non les membres à utiliser de tels clients relève de votre décision d’employeur — pensez à associer vos représentants du personnel.',
    },
    switchLabel: 'Autoriser les membres à connecter des agents IA externes',
    saving: 'Enregistrement…',
    activeConnections: 'Aucune connexion active. | 1 connexion active. | {n} connexions actives.',
    offHint: 'La désactivation met fin immédiatement à toutes les connexions de cet espace.',
    roleNote: 'Seul le propriétaire de l’espace ou un administrateur de la suite peut modifier ce réglage.',
    savedOn: 'Les agents IA externes sont activés. Les membres peuvent désormais connecter leur client IA.',
    savedOff: 'Les agents IA externes sont désactivés. | Les agents IA externes sont désactivés. 1 connexion a pris fin. | Les agents IA externes sont désactivés. {n} connexions ont pris fin.',
    disableConfirm: {
      title: 'Désactiver les agents IA externes ?',
      body: 'Aucune connexion n’est active pour le moment ; les membres ne pourront plus se connecter. | Cela met fin immédiatement à 1 connexion. | Cela met fin immédiatement à {n} connexions.',
      confirm: 'Désactiver',
    },
  },
  supportAccess: {
    revokeConfirm: 'L’accès du support prend fin immédiatement. L’équipe du support perd son accès à cet espace.',
    title: 'Accès du support',
    subtitle: 'Accès temporaire à votre espace, accordé par vous, pour notre équipe de support.',
    noAccess: 'Aucun accès',
    noAccessHint: 'Seuls le propriétaire de l’espace et les administrateurs de la suite peuvent examiner ces demandes.',
    empty: 'Aucun accès du support demandé',
    emptyHint: 'Lorsque notre support a besoin d’accéder à votre espace pour traiter un ticket, la demande apparaît ici.',
    pendingTitle: 'Demande d’accès en attente',
    pendingIntro: '{supporter} demande {days} jours d’accès à cet espace.',
    activeTitle: 'L’accès du support est actif',
    activeIntro: '{supporter} peut actuellement travailler dans cet espace.',
    historyTitle: 'Historique',
    revokeHint: 'La fin de l’accès prend effet en moins d’une minute.',
    expiringNow: 'Expire maintenant',
    remainingDays: 'encore {days} j {hours} h',
    remainingHours: 'encore {hours} h {minutes} min',
    remainingMinutes: 'encore {minutes} min',
    fields: {
      requestedAt: 'Demandé le',
      ticket: 'Ticket de support',
      duration: 'Durée',
      durationValue: '{days} jours',
      reason: 'Motif indiqué',
      approvedBy: 'Approuvé par',
      expiresAt: 'Expire le',
      remaining: 'Temps restant',
      grantedModules: 'Rôles accordés',
    },
    consent: { allRoles: 'La personne du support peut basculer dans chaque rôle proposé par ces modules — elle voit ce que voient vos collaborateurs, pas seulement la vue administrateur.', modulesHeading: 'Cet accès couvre :', via: 'via {module}',
      heading: 'Ce que vous approuvez',
      data: 'Le support pourra accéder aux données de cet espace dans tous les modules actifs, y compris les données personnelles des collaborateurs et des candidats.',
      audited: 'Chaque action est enregistrée dans votre journal d’audit et marquée comme action du support.',
      duration: 'L’accès prend fin automatiquement après {days} jours.',
      revocable: 'Vous pouvez y mettre fin à tout moment ; cela prend effet en moins d’une minute.',
    },
    actions: { approve: 'Approuver l’accès', deny: 'Refuser', revoke: 'Mettre fin maintenant' },
    status: {
      requested: 'En attente',
      active: 'Actif',
      denied: 'Refusé',
      revoked: 'Terminé',
      expired: 'Expiré',
      request_expired: 'Demande expirée',
    },
    columns: { supporter: 'Compte support', requestedAt: 'Demandé le', status: 'Statut', endedAt: 'Terminé le' },
    success: { approved: 'Accès du support approuvé.', denied: 'Demande refusée.', revoked: 'Accès du support terminé.' },
    errors: {
      consentChanged: 'Le texte de consentement a changé. Merci de le relire avant d’approuver.',
      selfApproval: 'Le compte demandeur ne peut pas approuver sa propre demande.',
    },
  },
  // Administration › Statutory rules (ADR 0091): the statutory rule catalogue
  // and the workspace's agreements and deviations, moved here from Time's
  // settings with the page.
  statutory: {
    title: 'Règles légales et accords',
    intro: 'Les règles légales s’appliquent automatiquement et sont tenues à jour de manière centralisée. Ici, vous indiquez seulement où votre entreprise s’en écarte – chaque dérogation nécessite un fondement, par exemple une convention collective ou un accord d’entreprise.',
    disclaimer: 'Valeurs d’orientation issues de la loi – pas un conseil juridique. Les conventions collectives peuvent être plus strictes.',
    // "Checked, fits us" (issue 713): the one-time confirmation of the statutory defaults.
    confirmation: {
      unchecked: {
        title: 'Pas encore vérifié',
        // The short sentence for someone who may read the page but not confirm (a support grant): no picker, no button.
        body: 'lumi démarre avec les règles légales par défaut. Si elles vous conviennent, confirmez-le. Si une convention collective ou un accord d’entreprise s’applique chez vous, créez une dérogation ci-dessous.',
        confirm: 'Vérifié, cela nous convient',
        // The mode picker (issue 780) is shown to someone who can confirm; the tile titles are the settings card's own (statutory.workspace.modeFlexible/modeStrict).
        lead: 'lumi démarre avec les règles légales par défaut – durée maximale de travail, pauses, repos. Décidez ce qui se passe lorsqu’une saisie en enfreint une, puis confirmez que les règles conviennent à votre entreprise.',
        standard: 'Par défaut',
        later: 'Vous pouvez modifier les deux à tout moment par la suite.',
        agreements: 'Une convention collective ou un accord d’entreprise s’applique-t-il chez vous, selon lequel une règle diffère ou ne s’applique pas ? Créez alors ci-dessous une {basis} – les avertissements s’y conforment. Il n’existe pas de mode sans avertissements.',
        agreementsBasis: 'dérogation avec son fondement',
        flexible: {
          personLabel: 'La personne', personText: 'voit à l’enregistrement quelle règle est enfreinte et de combien – la saisie est conservée.',
          managerLabel: 'Le management', managerText: 'voit les infractions de la semaine lors de la validation et décide avec la personne.',
          recordLabel: 'Le journal', recordText: 'consigne chaque infraction – pour vous, pas contre vous.',
        },
        strict: {
          personLabel: 'La personne', personText: 'ne peut pas enregistrer une saisie qui enfreint une règle appliquée – et voit pourquoi. Une pause manquante est enregistrée et affichée.',
          managerLabel: 'Le management', managerText: 'ne voit à la validation que ce qui subsiste malgré tout : pauses manquantes et clôtures automatiques.',
          fitLabel: 'Convient si', fitText: 'les exceptions ne doivent pas se produire chez vous – par exemple pour des mineurs.',
        },
      },
      // After a save that is not a review, while unconfirmed (issue 990): the next step, in place.
      afterSave: { body: 'Enregistré. Les règles de temps de travail ne sont pas encore confirmées pour autant – confirmez maintenant qu’elles vous conviennent.', confirm: 'Confirmer maintenant' },
      confirmed: { title: 'Vérifié', body: 'Confirmé le {date} par {name} : les règles légales nous conviennent.', bodyNoName: 'Confirmé le {date} : les règles légales nous conviennent.' },
      ownDeviation: { title: 'Vérifié', body: 'Votre espace de travail a ses propres dérogations : les règles ont donc été examinées.' },
      error: 'La confirmation n’a pas pu être enregistrée. Veuillez réessayer.',
    },
    noJurisdictions: 'Aucune juridiction n’est encore définie : il n’y a ni personnes avec un lieu de travail ni juridiction par défaut. Choisissez-en une ci-dessous pour afficher ici les règles légales.',
    jurisdictionEu: 'Directive européenne',
    jurisdictionDefault: '{name} (par défaut)',
    // Who the number is (issue 990): active employees in Time judged by this law —
    // on a tab that is not the default, only those whose work location is there;
    // on the default's tab, also everyone who falls back to it.
    headcountLine: 'Juridiction {country} : ces règles ne s’appliquent actuellement à personne. | Juridiction {country} : ces règles encadrent le temps de travail d’1 personne dans Temps qui travaille ici. | Juridiction {country} : ces règles encadrent le temps de travail de {count} personnes – tous les salariés actifs dans Temps qui travaillent ici.',
    headcountLineDefault: 'Juridiction {country} : ces règles ne s’appliquent actuellement à personne. | Juridiction {country} : ces règles encadrent le temps de travail d’1 personne dans Temps qui travaille ici ou relève de la juridiction par défaut. | Juridiction {country} : ces règles encadrent le temps de travail de {count} personnes – tous les salariés actifs dans Temps qui travaillent ici ou relèvent de la juridiction par défaut.',
    fallbackLine: 'Personnes sans lieu de travail, ou dont le lieu n’est pas couvert par le catalogue : {count} – {country} s’applique à elles.',
    createModels: 'Créer les modèles de temps de travail de ce pays',
    domains: {
      workingTime: 'Temps de travail',
      pay: 'Plages de majoration',
      overtime: 'Heures supplémentaires',
      leave: 'Congés',
    },
    rules: {
      maxDailyHours: 'Durée maximale quotidienne de travail',
      maxWeeklyHours: 'Durée maximale hebdomadaire de travail',
      breaks: 'Pauses',
      minDailyRest: 'Repos quotidien',
      nightWorkBan: 'Interdiction du travail de nuit',
      minWeeklyRest: 'Repos hebdomadaire',
      avgWeeklyHours: 'Durée hebdomadaire moyenne de travail',
      normalDailyHours: 'Durée normale quotidienne de travail',
      normalWeeklyHours: 'Durée normale hebdomadaire de travail',
      nightWindow: 'Période de nuit pour les majorations',
      nightCoreWindow: 'Cœur de nuit pour les majorations renforcées',
      overtimeThreshold: 'Seuil des heures supplémentaires (heures par semaine)',
      overtimeSurcharge: 'Majorations pour heures supplémentaires',
      minLeaveDays: 'Congés annuels minimaux',
    },
    kinds: {
      collectiveAgreement: 'Convention collective',
      worksAgreement: 'Accord d’entreprise',
      authorityPermit: 'Autorisation administrative',
      companyPolicy: 'Règle interne',
    },
    value: {
      hoursUnit: 'h',
      days: '{days} jours',
      breakStage: '{minutes} min au-delà de {hours} h',
      weeklyAverage: '{hours} h en moyenne sur {weeks} semaines',
      nightWorkBan: 'aucun travail entre {start} et {end}',
      tierFirst: '{percent} % dès la première heure supplémentaire',
      tierAfter: '{percent} % après {hours} heures supplémentaires',
      none: 'Aucune règle',
      switchedOff: 'Règle non appliquée (désactivée)',
    },
    status: {
      statutory: 'Légal',
      noStatutoryRule: 'Aucune règle légale',
      infoOnly: 'À titre indicatif',
      deviation: 'Dérogation',
      deviationStricter: 'Dérogation · plus stricte',
      deviationLooser: 'Dérogation · plus souple',
      deviationMoreFavourable: 'Dérogation · plus favorable que la loi',
      deviationLessFavourable: 'Dérogation · moins favorable que la loi',
      deviationEqual: 'Dérogation · identique à la loi',
      deviationMixed: 'Dérogation · en partie plus stricte, en partie plus souple',
      deviationMixedFavourable: 'Dérogation · en partie plus favorable, en partie moins',
    },
    hint: {
      stricter: 'Plus strict que la loi – admis quel que soit le fondement.',
      looser: 'Plus souple que la loi – cela nécessite une convention collective, un accord d’entreprise ou une autorisation administrative comme fondement.',
      moreFavourable: 'Plus favorable que la loi – admis quel que soit le fondement.',
      lessFavourable: 'Moins favorable que la loi – cela nécessite une convention collective, un accord d’entreprise ou une autorisation administrative comme fondement.',
      mixed: 'En partie plus strict, en partie plus souple que la loi – cela nécessite une convention collective, un accord d’entreprise ou une autorisation administrative comme fondement.',
      mixedFavourable: 'En partie plus favorable, en partie moins favorable que la loi – cela nécessite une convention collective, un accord d’entreprise ou une autorisation administrative comme fondement.',
      equal: 'Identique à la valeur légale – aucune dérogation n’est nécessaire.',
      incomparable: 'Pour cette règle, il n’y a pas de « plus strict » ou « plus souple » – tout fondement convient.',
      blocked: 'Une règle interne ne peut pas rester en deçà de la loi. Choisissez comme fondement une convention collective, un accord d’entreprise ou une autorisation administrative – ou une valeur au moins conforme à la loi.',
    },
    table: {
      rule: 'Règle',
      applies: 'S’applique',
      note: 'Remarque sur le cadre légal',
      deviate: 'Déroger',
      backToStatute: 'Revenir à la loi',
      statutoryWouldBe: 'La loi prévoirait : {value}',
      statutoryWouldBeNone: 'La loi ne prévoit aucune règle ici.',
      basis: 'Fondement : {name}',
      basisWithClause: 'Fondement : {name}, {clause}',
      coveredDeviation: 'Avec le code de convention {code} : {value} ({name})',
      futureDeviation: 'À partir du {date} : {value} ({name})',
      fallbackApplies: 'La loi ne fixe aucune plage ici – celle-ci s’applique jusqu’à ce qu’un accord en fixe une autre.',
      fallbackWouldBe: 'La loi ne fixe aucune plage ici – sans la dérogation, ce serait : {value}',
      editDeviationOf: 'Modifier la dérogation de « {name} »',
      backToStatuteOf: 'Ramener la dérogation de « {name} » à la loi',
    },
    notice: {
      fallback: 'Le catalogue des règles légales est temporairement indisponible. La base intégrée est affichée ; des modifications récentes peuvent manquer.',
      unjudged: 'Personnes auxquelles aucune règle légale ne s’applique actuellement : {count}. Elles n’ont pas de lieu de travail et aucune juridiction par défaut n’est définie – choisissez-en une ci-dessous.',
      upcoming: 'À partir du {date}, la règle légale « {rule} » passe à : {value}.',
      upcomingNone: 'À partir du {date}, la règle légale « {rule} » ne s’applique plus.',
      upcomingDeviationStays: 'Votre dérogation reste en vigueur.',
      reviewTitle: 'À vérifier : {rule}',
      review: 'La valeur légale a changé depuis que cette dérogation a été définie ({agreement}). La loi prévoit désormais : {statutory}. Votre dérogation : {deviation}.',
      keepDeviation: 'Conserver la dérogation',
    },
    minors: {
      title: 'Jeunes de moins de 18 ans',
      headcount: 'Personnes : {count}',
      headcountNone: 'aucune actuellement',
      hint: 'Pour les personnes de moins de 18 ans, ces règles légales de protection des jeunes s’appliquent à la place des règles générales – automatiquement, d’après la date de naissance enregistrée dans Personnel. Les accords n’y dérogent pas.',
      generalApplies: 'Pas encore de règle propre – la règle générale s’applique d’ici là.',
      upcoming: 'À partir du {date} : {value}',
      upcomingNone: 'À partir du {date}, cette règle de protection des jeunes ne s’applique plus.',
    },
    form: {
      value: 'Valeur dérogatoire',
      daysUnit: 'jours',
      stageAfterHours: 'Temps de travail supérieur à (h)',
      stageMinutes: 'Pause totale (min)',
      tierAfterHours: 'À partir de (heures supplémentaires par semaine)',
      tierPercent: 'Majoration (%)',
      addStep: 'Ajouter un palier',
      removeStep: 'Supprimer le palier {row}',
      stageAfterHoursRow: 'Palier {row} : temps de travail supérieur à (h)',
      stageMinutesRow: 'Palier {row} : pause totale (min)',
      tierAfterHoursRow: 'Palier {row} : à partir de (heures supplémentaires par semaine)',
      tierPercentRow: 'Palier {row} : majoration (%)',
      averageHours: 'Heures par semaine en moyenne',
      averageWeeks: 'Période de référence (semaines)',
      windowStart: 'Début',
      windowEnd: 'Fin',
      windowHint: 'Si la fin précède le début, la plage se prolonge après minuit.',
      statutoryIs: 'La loi prévoit : {value}',
      comparisonBase: 'Sans règle légale, {value} s’applique – la dérogation est mesurée par rapport à cette valeur.',
      basis: 'Fondement',
      basisHint: 'L’accord sur lequel repose la dérogation.',
      basisPick: 'Choisir un fondement…',
      basisNew: 'Créer un nouveau fondement…',
      basisRequired: 'Veuillez choisir un fondement.',
      clause: 'Référence de la clause',
      clauseHint: 'Où figure la disposition, p. ex. « art. 4, al. 2 ». Facultatif.',
      invalid: {
        hours: 'Indiquez des heures : plus de 0 et au maximum 168.',
        days: 'Indiquez des jours : plus de 0 et au maximum 366.',
        breakLadder: 'Vérifiez les paliers : 1 à 6 paliers, croissants selon le temps de travail (plus de 0 jusqu’à 24 h), une pause de plus de 0 jusqu’à 480 min et jamais inférieure à celle du palier précédent.',
        weeklyAverage: 'Vérifiez les valeurs : heures supérieures à 0 et au maximum 168, période de référence de 1 à 104 semaines.',
        timeWindow: 'Indiquez une heure de début et une heure de fin ; elles doivent être différentes.',
        percentTiers: 'Vérifiez les paliers : 1 à 6 paliers, le premier à partir de 0 heure supplémentaire, les suivants croissants ; majoration entre 0 et 300 %, avec deux décimales au plus.',
      },
    },
    agreement: {
      name: 'Nom',
      title: 'Accords',
      subtitle: 'Conventions collectives, accords d’entreprise, autorisations et règles internes – les fondements de vos dérogations.',
      new: 'Nouvel accord',
      edit: 'Modifier l’accord',
      empty: 'Aucun accord pour l’instant – les règles légales s’appliquent partout.',
      inactive: 'Pas en vigueur actuellement',
      migrated: 'Repris des anciens paramètres',
      noDeviations: 'Aucune dérogation pour l’instant. Définissez-les ci-dessus, sur la règle concernée.',
      needsReview: 'À vérifier',
      kind: 'Type d’accord',
      companyPolicyHint: 'Une règle interne ne peut être que plus stricte ou plus favorable que la loi.',
      nameHint: 'Par exemple « Convention collective de la métallurgie » ou « Accord pauses 2026 ».',
      nameRequired: 'Veuillez nommer l’accord.',
      reference: 'Numéro de référence',
      referenceHint: 'Facultatif, p. ex. numéro d’enregistrement ou numéro de décision.',
      jurisdiction: 'Juridiction',
      validFrom: 'Valable à partir du',
      validFromRequired: 'Veuillez indiquer à partir de quand l’accord s’applique.',
      validTo: 'Valable jusqu’au',
      validToHint: 'Laisser vide si l’accord est à durée indéterminée.',
      validSince: 'valable à partir du {from}',
      validRange: 'valable du {from} au {to}',
      scope: 'S’applique à',
      scopeAll: 'toutes les personnes de cette juridiction',
      scopeCovered: 'uniquement les personnes liées par la convention',
      scopeCoveredCode: 'uniquement le code de convention {code}',
      coverageCode: 'Code de convention',
      coverageCodeHint: 'Le code est renseigné sur le contrat de travail d’une personne dans Personnel. L’accord ne s’applique qu’aux personnes portant exactement ce code.',
      deleteTitle: 'Supprimer « {name} » ?',
      deleteConfirm: 'La suppression de l’accord supprime aussi ses dérogations (nombre : {count}). Ces règles suivront à nouveau la loi.',
      deleteConfirmEmpty: 'L’accord ne comporte aucune dérogation ; les règles en vigueur ne changent pas.',
      editDeviation: 'Modifier la dérogation : {rule}',
      removeDeviation: 'Revenir à la loi : {rule}',
    },
    backConfirm: {
      title: '« {rule} » : revenir à la loi ?',
      body: 'La dérogation sera supprimée. La valeur légale s’appliquera à nouveau : {value}.',
      bodyNone: 'La dérogation sera supprimée. La loi ne prévoit aucune règle ici – plus aucune ne s’appliquera.',
      bodyFallback: 'La dérogation sera supprimée. La loi ne prévoit aucune règle ici – {value} s’appliquera à nouveau.',
    },
    workspace: {
      title: 'Paramètres de l’espace de travail',
      defaultJurisdiction: 'Juridiction par défaut',
      defaultJurisdictionHint: 'S’applique aux personnes sans lieu de travail ou dont le lieu de travail n’est pas couvert par le catalogue.',
      noDefault: 'Aucune par défaut',
      mode: 'Lorsqu’une saisie enfreint une règle',
      modeFlexible: 'Avertir et consigner',
      modeFlexibleHint: 'La saisie est enregistrée. L’infraction est affichée et consignée.',
      modeStrict: 'Bloquer la saisie',
      modeStrictHint: 'Une saisie qui enfreint une règle appliquée ne peut pas être enregistrée.',
      originSignup: 'Repris du pays indiqué par votre entreprise lors de l’inscription : {country}.',
      originFallbackPrevious: 'Tant que le pays indiqué par votre entreprise lors de l’inscription n’est pas connu et présent dans le catalogue, les règles de {current} s’appliquent – celles selon lesquelles cet espace de travail était évalué jusqu’ici.',
      originFallbackUnknown: 'Le pays de votre entreprise n’est pas encore connu ; le minimum européen s’applique donc jusqu’à ce que quelqu’un choisisse le pays ici.',
      originFallbackUncovered: 'Lors de l’inscription, votre entreprise a indiqué {country}. Le catalogue ne contient pas encore de règles pour ce pays ; le minimum européen s’applique donc.',
      originFallbackCovered: 'Lors de l’inscription, votre entreprise a indiqué {country}, dont les règles figurent désormais dans le catalogue. Choisissez-le ici pour les appliquer – d’ici là, le minimum européen s’applique.',
    },
    toast: {
      settingsSaved: 'Paramètres enregistrés',
      deviationSaved: 'Dérogation enregistrée',
      deviationConfirmed: 'Dérogation confirmée',
      backToStatute: 'Dérogation supprimée – la loi s’applique à nouveau',
      agreementSaved: 'Accord enregistré',
      agreementDeleted: 'Accord supprimé',
      modelsCreated: 'Modèles de temps de travail créés : {count}',
      modelsExist: 'Les modèles de temps de travail de ce pays existent déjà.',
    },
    errors: {
      rival: '« {name} » fixe déjà cette règle pour les mêmes personnes sur une période qui se chevauche.',
      validToBeforeFrom: 'La fin de validité ne peut pas précéder son début.',
      coverageCodeRequired: 'Veuillez indiquer le code de convention auquel l’accord s’applique.',
      invalidValue: 'La valeur n’est pas valable pour cette règle. Veuillez la vérifier.',
      jurisdictionUnknown: 'Cette juridiction ne figure pas dans le catalogue des règles légales.',
      dateInvalid: 'Veuillez indiquer une date valide.',
      labelInvalid: 'Vérifiez les champs de texte : le nom est obligatoire et aucun champ ne peut dépasser 160 caractères.',
      noModelPresets: 'Il n’existe pas de modèles de temps de travail préparés pour ce pays.',
      kindInvalid: 'Choisissez le type d’accord dans la liste.',
      modeInvalid: 'Choisissez ce qui se passe lorsqu’une saisie enfreint une règle.',
      ruleUnknown: 'Cette version de l’application ne connaît pas cette règle. Veuillez recharger la page.',
      ruleInfoOnly: 'Cette règle est affichée à titre d’information uniquement – on ne peut pas y déroger.',
    },
    // The workspace page around the section (Administration › Statutory rules):
    // a workspace without Time, and a viewer time-api does not admit.
    page: {
      timeInactiveTitle: 'Temps n’est pas actif dans cet espace de travail',
      timeInactive: 'Les règles légales s’appliquent au temps de travail saisi dans Temps. Dès que Temps fera partie de cet espace de travail, c’est ici que vous indiquerez où votre entreprise y déroge.',
      noAccess: 'Vous ne pouvez pas gérer les règles légales de cet espace de travail. Le propriétaire de l’espace de travail, l’administration de suite et les membres de Temps autorisés à gérer la conformité le peuvent.',
    },
  },
  // Administration › Training occupations (ADR 0092).
  trainingOccupations: {
    title: 'Métiers de formation',
    columns: {
      occupation: 'Métier de formation',
      duration: 'Durée',
      regulation: 'Règlement de formation',
      apprentices: 'Apprentis',
    },
    duration: '{count} mois',
    regulationIssued: 'du {date}',
    regulationValidFrom: 'en vigueur depuis le {date}',
    areas: {
      IH: 'Industrie et commerce (IHK)',
      Hw: 'Artisanat (HWK)',
      oeD: 'Fonction publique',
      Lw: 'Secteur agricole',
      FB: 'Professions libérales',
      Hausw: 'Économie domestique',
      See: 'Navigation maritime',
    },
    branches: {
      specialisations: 'Spécialisations',
      focuses: 'Dominantes',
      any: 'Spécialisations / dominantes',
    },
    requirements: {
      onWall: 'Positions du règlement de formation sur le mur des compétences : {count}',
      version: 'règlement du {date}',
      none: 'Les positions du règlement de formation ne sont pas encore disponibles. Elles apparaîtront sur le mur des compétences dès que l’opérateur de la plateforme les aura importées.',
      versions: 'Les apprentis sont formés selon {count} versions du règlement – chacun reste soumis à la version en vigueur au début de sa formation.',
    },
    state: {
      notSelectable: 'N’est plus proposé à la sélection',
      notSelectableHint: 'L’opérateur de la plateforme ne propose plus ce métier à la sélection. Votre espace de travail le conserve, ainsi que ses apprentis – mais une fois retiré, il ne pourra plus être ajouté.',
      withdrawn: 'Reconnaissance retirée',
      withdrawnHint: 'La reconnaissance par l’État de ce métier a été abrogée, ou il ne figure plus au répertoire des métiers de formation reconnus. Les apprentis en cours de formation la terminent ; il ne peut plus être ajouté.',
      unknown: 'Absent du catalogue',
      unknownHint: 'Cette entrée a été saisie avant l’existence du catalogue et ne correspond à aucun de ses métiers. Elle peut seulement être retirée – ajoutez à la place le métier correspondant depuis le catalogue.',
    },
    offered: {
      title: 'Notre offre',
      intro: 'Les métiers de formation reconnus dans lesquels votre entreprise forme. Seuls ceux-ci peuvent être choisis pour un apprenti.',
      emptyTitle: 'Aucun métier de formation proposé pour l’instant',
      empty: 'Choisissez dans le catalogue ci-dessous les métiers dans lesquels votre entreprise forme. Vous pourrez ensuite les attribuer à vos apprentis.',
      browse: 'Choisir dans le catalogue',
      remove: 'Retirer',
      removeNamed: 'Retirer {title} de l’offre',
    },
    catalogue: {
      title: 'Ajouter depuis le catalogue',
      intro: 'Les métiers de formation reconnus en Allemagne que votre espace de travail ne propose pas encore. Le catalogue est tenu à jour de manière centralisée.',
      unavailableTitle: 'Le catalogue est actuellement inaccessible',
      unavailable: 'Votre offre ci-dessus est affichée à partir de ce que cet espace de travail a enregistré. Des métiers pourront de nouveau être ajoutés dès que le catalogue sera de retour.',
      allOffered: 'Votre espace de travail propose déjà tous les métiers du catalogue.',
      searchPlaceholder: 'Intitulé ou spécialisation',
      areaLabel: 'Domaine',
      areaAll: 'Tous les domaines',
      count: 'Métiers trouvés : {shown} sur {total}',
      noMatches: 'Aucun métier ne correspond à votre recherche.',
      resetFilters: 'Réinitialiser la recherche',
      showMore: 'Afficher plus',
      add: 'Ajouter',
      addNamed: 'Ajouter {title} à l’offre',
    },
    removeConfirm: {
      title: 'Retirer « {title} » de l’offre ?',
      apprentices: 'Apprentis actuellement rattachés à ce métier : {count}. Ils conservent leur métier et terminent leur formation – il ne peut simplement plus être choisi pour de nouveaux apprentis.',
      final: 'Une fois retiré, ce métier ne pourra plus être ajouté.',
      confirm: 'Retirer de l’offre',
    },
    toast: {
      added: '« {title} » fait désormais partie de votre offre',
      removed: '« {title} » n’est plus proposé',
    },
    errors: {
      notOfferable: '« {title} » n’a pas pu être ajouté : ce métier a été désactivé ou retiré entre-temps. La liste a été actualisée.',
      catalogueUnavailable: 'Le catalogue est actuellement inaccessible, rien ne peut donc être ajouté. Veuillez réessayer plus tard.',
    },
    page: {
      moduleInactiveTitle: 'Apprentissage n’est pas actif dans cet espace de travail',
      moduleInactive: 'Les métiers de formation sont proposés pour les apprentis gérés dans le module Apprentissage. Dès qu’il fera partie de cet espace de travail, c’est ici que vous choisirez dans quels métiers votre entreprise forme.',
      noAccess: 'Vous ne pouvez pas gérer les métiers de formation de cet espace de travail. Le propriétaire de l’espace de travail, l’administration de suite et les membres du module Apprentissage autorisés à le gérer le peuvent.',
    },
  },
};
